import {
  animate,
  style,
  state,
  transition,
  trigger,
  stagger,
  group
} from "@angular/animations";
import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  ViewChildren,
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  ViewChild
} from "@angular/core";
import { Observable } from "rxjs/Observable";
import { ContainerService } from "../_services/container.service";
import { container, filterValues } from "../_models/container";
import { PagingService } from "../_services/paging.service";
import { Filters, filterValue } from "../_models/container";
import { filter } from "rxjs/operators/filter";
import { forEach } from "@angular/router/src/utils/collection";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { TradeContainerPipe } from "./container.pipe";
import { TradeSortbyPipe } from "./sortby.pipe";
import { query } from "@angular/core/src/animation/dsl";
import { Title, DomSanitizer } from "@angular/platform-browser";
import { PortaluserprofileService, ITradePortalService } from "../_services/index";
import { GlobalValues } from "../common/_common";
import { Http } from "@angular/http";
import "rxjs/add/observable/of";
import "rxjs/add/operator/map";
import { $ } from "protractor";
import { retry } from "rxjs/operators";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import {  Subscription } from 'rxjs';

@Component({
  selector: "app-buycontainer",
  templateUrl: "./buycontainertrade.component.html",
  styleUrls: ["./buycontainertrade.component.scss"],
  providers: [
    ContainerService,
    PagingService,
    TradeContainerPipe,
    PortaluserprofileService,
    TradeSortbyPipe
  ],
  animations: [
    trigger("containeranmiate", [
      state("in", style({ opacity: 1, transform: "translateX(0)" })),
      transition("void => *", [
        style({
          opacity: 0,
          transform: "translateX(-100%)"
        }),
        animate("0.2s ease-in")
      ]),
      transition("* => void", [
        animate(
          "0.2s 0.1s ease-out",
          style({
            opacity: 0,
            transform: "translateX(100%)"
          })
        )
      ])
    ])
  ]
})
export class BuycontainertradeComponent implements OnInit {
  subscription: Subscription;
  intervalId: number;
  cstmr: any;
  container_detail: Array<container>;
  userCountrys: Array<any> = [];
  dropdownList = [];
  sortfilterlist: string;
  selectedSize: boolean;
  selectedSizea: boolean;
  showselected: boolean;
  totalItems: any;
  filters: Filters;
  filterTitle: Array<string>;
  cntyfilterTitle: Array<string>;
  filterList: any;
  FiltersData: Array<any> = [];
  cntyFiltersData: Array<any> = [];
  number_container: number = 0;
  FilterValue: filterValue[] = [];
  cntyFilterValue: filterValue[] = [];
  toggler: boolean = true;
  optionslist: Array<any> = [];
  modalRef: BsModalRef;
  selectedfilter: Array<any> = [];
  cntyselectedfilter: Array<any> = [];
  p: any;
  show: boolean = false;
  map: any;
  cntymap: any;
  index: number;
  count: Array<any> = [];
  cntycount: Array<any> = [];
  filtersummary: Array<string> = [];
  summary: Array<string> = [];
  summaryoptions: Array<any> = [];
  userdetails: string;
  usertype: string;
  username: string;
  orderby: string = null;
  orderstatus: boolean = false;
  orderbyststus: string = "'ctY_NAM','cntnR_SZ_CD','cntnR_TYP_CD','clR_CD_NM'";
  filterIndex: number = 0;
  cntyfilterIndex: number = 0;
  loading: boolean = true;
  slctdCustomer: string;
  selcntry: Array<any> = [];
  selcty: Array<any> = [];
  seldopt: Array<any> = [];

  filteredData: Array<any> = [];
  checkboxFilterValue: Array<any> = [];

  LstOfCnty: Array<any> = [];
  sldCstmr: Array<any> = [];
  sldCnty: Array<any> = [];
  sldCity: Array<any> = [];
  sldDpt: Array<any> = [];
  sldSlCnd: Array<any> = [];
  sldCnttype: Array<any> = [];
  sldCntsize: Array<any> = [];
  sldClrcd: Array<any> = [];
  sldPrc: Array<any> = [];

  fldCnty: Array<any> = [];
  fldCity: Array<any> = [];
  fldDpt: Array<any> = [];
  cmmfld: Array<any> = [];

  cityshowmorecount: number;
  cityshowstatus: boolean;
  cntyshowmorecount: number;
  cstmrshowmorecount: number;
  cntyshowstatus: boolean;
  cstmrshowstatus: boolean;
  dptshowmorecount: number;
  dptshowstatus: boolean;
  slcndshowmorecount: number;
  slcndshowstatus: boolean;
  cnttypshowmorecount: number;
  cnttypshowstatus: boolean;
  cntcdshowmorecount: number;
  cntcdshowstatus: boolean;
  prcshowmorecount: number;
  prceshowstatus: boolean;
  cntszshowmorecount: number;
  cntszshowstatus: boolean;
  customer: Array<any> = [];
  customerBind: Array<any> = [];
  cstmrLst: Array<filterValues> = [];
  cntyLst: Array<filterValues> = [];
  cityLst: Array<filterValues> = [];
  dptLst: Array<filterValues> = [];
  slcndLst: Array<filterValues> = [];
  cnttypLst: Array<filterValues> = [];
  cntszLst: Array<filterValues> = [];
  clrcdLst: Array<filterValues> = [];
  pceLst: Array<filterValues> = [];
  info:string;
  someProperty = true;
  somePropertya = false;
  customrMap: Array<any> = [];
  customrCheckMap;
  name: Array<any> = [];
  unit: Array<any> = [];
  mobFilterTitle: string;
  private sub;
  interval :Number;
  Priceval: Array<any> = [
    "0 - 1000",
    "1001 - 1500",
    "1501 - 2000",
    "2001 - 2500",
    "2501 - 3000",
    "3001 - Above"
  ];
  
  
 
  Pricecount: Array<any> = [];
  totalPrice: any = [];
  constructor(
    private containers: ContainerService,
    private itradeservice: ITradePortalService,
    private PortaluserprofileService: PortaluserprofileService,
    private pagerService: PagingService,
    private modalService: BsModalService,
    private titleService: Title,
    private http: Http,
    private spinnerService: Ng4LoadingSpinnerService,
   
  ) {
    this.sub = Observable.interval(10000)
    .subscribe((val) => { console.log('called'); });
    
   }
  iconb() {
    this.selectedSize = true;
    this.selectedSizea = false;
    this.someProperty = false;
    this.somePropertya = true;
    return this.selectedSize, this.somePropertya;
  }
  icona() {
    this.selectedSizea = true;
    this.selectedSize = false;
    this.somePropertya = false;
    this.someProperty = true;
    return this.selectedSizea, this.selectedSize;
  }

  // this.sub = Observable.interval(10000)
  // .subscribe((val) => { console.log('called'); });


  ngOnInit() {
    this.loading=false;
    if (JSON.parse(localStorage.getItem("Interval"))){
   this.interval=JSON.parse(localStorage.getItem("Interval"));
    const source = Observable.interval(this.interval["token"]["interval"]);
    const text = 'Your Text Here';
    this.subscription = source.subscribe(val => this.opensnack(text));
    }
    this.titleService.setTitle(GlobalValues.containerTitle);

    this.cityshowmorecount = 2;
    this.cityshowstatus = true;
    this.cntyshowmorecount = 2;
    this.cstmrshowmorecount = 2;
    this.cstmrshowstatus = true;
    this.cntyshowstatus = true;
    this.dptshowmorecount = 2;
    this.dptshowstatus = true;
    this.slcndshowmorecount = 2;
    this.slcndshowstatus = true;
    this.cnttypshowmorecount = 2;
    this.cnttypshowstatus = true;
    this.cntcdshowmorecount = 2;
    this.cntcdshowstatus = true;
    this.prcshowmorecount = 2;
    this.prceshowstatus = true;
    this.cntszshowmorecount = 2;
    this.cntszshowstatus = true;

    // this.getContainers();
    this.userdetails = JSON.parse(localStorage.getItem("currentUser"));
    this.usertype = JSON.parse(localStorage.getItem("UserType"));
    this.slctdCustomer = JSON.parse(localStorage.getItem('customer'));
    if (this.userdetails) {
      this.username = this.userdetails["username"];
    }
    GlobalValues.username = this.username;
    this.itradeservice.getTradeCustomers(this.username)
      .subscribe(
        data => {
          this.customer = data;
          if (this.slctdCustomer) {
          for (var i = 0; i < this.customer.length; i++) {
            if (this.customer[i].cstmR_ID != this.slctdCustomer['cstmrid']) {
              this.customer[i].selected = false;
            } else {
              this.customer[i].selected = true;
            }
          }
        }
          this.customerBind=this.customer;
        }

      );
    if (this.slctdCustomer) {
      for (var i = 0; i < this.customer.length; i++) {
        if (this.customer[i].cstmR_ID != this.slctdCustomer['cstmrid']) {
          this.customer[i].selected = false;
        } else {
          this.customer[i].selected = true;
        }
      }
      this.customerBind=this.customer;
     
      this.getContainers(this.slctdCustomer['cstmrid'])
    } else {
      this.info="Please select the customer filter to list the containers";
      this.getContainers('1111');
    }


    //this.init();

    this.dropdownList = [
      // { id: 1, itemName: "Size low-high" },
      // { id: 2, itemName: "Size high-low" },
      { id: 3, itemName: "Grade New" },
      { id: 4, itemName: "Grade Used" }
    ];
   

  }
  ngOnDestroy(){
    this.subscription && this.subscription.unsubscribe();
  }
  opensnack(text) {
    // I've just commented this so that you're not bombarded with an alert.
    // alert(text);
    this.clearfilter();
    localStorage.removeItem("storedFilter");
    this.toggleback();
    this.slctdCustomer = JSON.parse(localStorage.getItem('customer'));
   this.getContainers(this.slctdCustomer['cstmrid']);
   

  }
   key: string = "name"; //set default
  reverse: boolean = false;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }
  getContainers(cstmrid) {
    const vm = this;
    this.userdetails = JSON.parse(localStorage.getItem("currentUser"));
    this.usertype = JSON.parse(localStorage.getItem("UserType"));
    if (this.userdetails) {
      this.username = this.userdetails["username"];
    }
    GlobalValues.username = this.username;
    //  this.itradeservice.getTradeCustomers(this.username)
    //  .subscribe(
    //    data =>{
    //   this.customer=data;
    //    }
    //  );
    this.containers.getProductTrade(cstmrid).subscribe(data => {
   
      this.container_detail = data;
      this.number_container = this.container_detail.length;
      if (this.container_detail.length ==0 && cstmrid!="1111"  )
{
 this.info="No Containers Available";
}      GlobalValues.cntrDtls = data;
      for (let i in this.container_detail) {
        this.container_detail[i].Image =
          "assets/images/" +
          this.container_detail[i]["clR_CD_ID"] +
          this.container_detail[i]["cntnR_SZ_CD"] +
          this.container_detail[i]["cntnR_TYP_CD"] +
          ".jpg";
      }
      if (localStorage.getItem("storedFilter")) {
        let storeCheck = JSON.parse(localStorage.getItem("storedFilter"));
        this.cntyLst = storeCheck.cntyLst;
        this.sldCnty = storeCheck.sldCnty;
        this.sldCity = storeCheck.sldCity;
        this.sldDpt = storeCheck.sldDpt;
        this.sldSlCnd = storeCheck.sldSlCnd;
        this.sldCnttype = storeCheck.sldCnttype;
        this.sldCntsize = storeCheck.sldCntsize;
        this.sldClrcd = storeCheck.sldClrcd;
        this.sldPrc = storeCheck.sldPrc;
        this.cityLst = storeCheck.cityLst;
        this.dptLst = storeCheck.dptLst;
        this.slcndLst = storeCheck.slcndLst;
        this.cnttypLst = storeCheck.cnttypLst;
        this.cntszLst = storeCheck.cntszLst;
        this.clrcdLst = storeCheck.clrcdLst;
        this.pceLst = storeCheck.pceLst;


        this.doFilter("Price", "", "");
        this.container_detail.sort(function (a, b) {

          var a_cntrY_NAM = a.cntrY_NAM;
          var b_cntrY_NAM = b.cntrY_NAM;
          var a_ctY_NAM = a.ctY_NAM;
          var b_ctY_NAM = b.ctY_NAM;
          var a_cntnR_SZ_CD = a.cntnR_SZ_CD;
          var b_cntnR_SZ_CD = b.cntnR_SZ_CD;
          var a_cntnR_TYP_CD = a.cntnR_TYP_CD;
          var b_cntnR_TYP_CD = b.cntnR_TYP_CD;
          var a_clR_CD_NM = a.clR_CD_NM;
          var b_clR_CD_NM = b.clR_CD_NM;

          if (a_cntrY_NAM < b_cntrY_NAM) {
            return -1;
          }
          else if (a_cntrY_NAM > b_cntrY_NAM) {
            return 1;
          }
          else {
            if (a_ctY_NAM < b_ctY_NAM) {
              return -1;
            }
            else if (a_ctY_NAM > b_ctY_NAM) {
              return 1;
            }
            else {
              if (a_cntnR_SZ_CD < b_cntnR_SZ_CD) {
                return -1;
              }
              else if (a_cntnR_SZ_CD > b_cntnR_SZ_CD) {
                return 1;
              }
              else {
                if (a_cntnR_TYP_CD < b_cntnR_TYP_CD) {
                  return -1;
                }
                else if (a_cntnR_TYP_CD > b_cntnR_TYP_CD) {
                  return 1;
                }
                else {
                  if (a_clR_CD_NM < b_clR_CD_NM) {
                    return -1;
                  }
                  else if (a_clR_CD_NM > b_clR_CD_NM) {
                    return 1;
                  }
                }
              }
            }

          }
        })
      } else {
        this.getFilter();

      }
    });
    // this.containers.getUserCountry(this.username).subscribe(
    //   data1 =>{
    //  this.userCountrys=data1;
    //  console.log(this.userCountrys);
    //   }
    // );

    //this.loading = false;

  }

 
  openModal(template: TemplateRef<any>) {
    //this.customer=this.customerBind;
   // this.cstmrLst=this.customerBind;
    this.modalRef = this.modalService.show(template);
   
  }
  toggleCstmrfilter(type: string){
     this.customer=this.customerBind;
     this.cstmrLst=this.customerBind;
    this.mobFilterTitle = type;
    this.optionslist=[];
     // this.selectedfilter = this.sldCnty;
      this.toggler = !this.toggler;
  }

  togglefilter(type: string) {
    this.cstmrLst=[];
    this.customer=[];
    if (type == "Customer") {
    this.cstmrLst=[];
    this.customer=[];
      this.toggler = !this.toggler;
    }
    if (type == "Country") {
      this.optionslist = this.cntyLst;
      this.mobFilterTitle = type;
      this.selectedfilter = this.sldCnty;
      this.toggler = !this.toggler;
    }
    if (type == "City") {
      this.optionslist = this.cityLst;
      this.mobFilterTitle = type;
      this.selectedfilter = this.sldCity;
      this.toggler = !this.toggler;
    }
    if (type == "Depot") {
      this.optionslist = this.dptLst;
      this.mobFilterTitle = type;
      this.selectedfilter = this.sldDpt;
      this.toggler = !this.toggler;
    }
    if (type == "SaleCondition") {
      this.optionslist = this.slcndLst;
      this.mobFilterTitle = type;
      this.selectedfilter = this.sldSlCnd;
      this.toggler = !this.toggler;
    }
    if (type == "ContainerType") {
      this.optionslist = this.cnttypLst;
      this.mobFilterTitle = type;
      this.selectedfilter = this.sldCnttype;
      this.toggler = !this.toggler;
    }
    if (type == "ContainerSize") {
      this.optionslist = this.cntszLst;
      this.mobFilterTitle = type;
      this.selectedfilter = this.sldCntsize;
      this.toggler = !this.toggler;
    }
    if (type == "ColourCode") {
      this.optionslist = this.clrcdLst;
      this.mobFilterTitle = type;
      this.selectedfilter = this.sldClrcd;
      this.toggler = !this.toggler;
    }
    if (type == "Price") {
      this.optionslist = [];
      // this.optionslist = this.Priceval;
      this.mobFilterTitle = type;
      this.selectedfilter = this.sldPrc;
      this.toggler = !this.toggler;
    }

    // this.toggler = !this.toggler;
    // this.index = index;
  }
  toggleback() {
    this.toggler = true;
  }

  logCheckboxmobile(filterval: string, value: any) {
    const vm = this;
    let index: number;
    if (value.checked) {
      vm.selectedfilter.push(filterval);
    } else {
      index = vm.selectedfilter.indexOf(filterval);
      vm.selectedfilter.splice(index, 1);
    }
  }

  filterCheckBoxDetail(type, item, checkbox) {
    const vm = this;
    let index: number;
    let isChecked = checkbox.checked;
    switch (type) {
      case "Customer": {
        if (isChecked) {
         // this.sldCstmr.push(item);

        } else {
          index = vm.sldCstmr.indexOf(item);
          vm.sldCstmr.splice(index, 1);
        }
        break;
      }
      case "Country": {
        if (isChecked) {
          this.sldCnty.push(item);
          this.sldCity = [];
          this.sldDpt = [];
          this.sldClrcd = [];
          this.sldCntsize = [];
          this.sldCnttype = [];
          this.sldPrc = [];
          this.sldSlCnd = [];
        } else {
          index = vm.sldCnty.indexOf(item);
          vm.sldCnty.splice(index, 1);
        }
        break;
      }
      case "City": {
        if (isChecked) {
          this.sldCity.push(item);
          // this.sldCity = [];
          this.sldDpt = [];
          this.sldSlCnd = [];
          this.sldClrcd = [];
          this.sldCntsize = [];
          this.sldCnttype = [];
          this.sldPrc = [];
        } else {
          index = vm.sldCity.indexOf(item);
          vm.sldCity.splice(index, 1);
        }
        break;
      }
      case "Depot": {
        if (isChecked) {
          this.sldDpt.push(item);
          // this.sldCity = [];
          // this.sldDpt = [];
          this.sldSlCnd = [];
          this.sldClrcd = [];
          this.sldCntsize = [];
          this.sldCnttype = [];
          this.sldPrc = [];
        } else {
          index = vm.sldDpt.indexOf(item);
          vm.sldDpt.splice(index, 1);
        }
        break;
      }
      case "SaleCondition": {
        if (isChecked) {
          this.sldSlCnd.push(item);
          // this.sldCity = [];
          // this.sldDpt = [];
          // this.sldSlCnd=[];
          this.sldClrcd = [];
          this.sldCntsize = [];
          this.sldCnttype = [];
          this.sldPrc = [];
        } else {
          index = vm.sldSlCnd.indexOf(item);
          vm.sldSlCnd.splice(index, 1);
        }
        break;
      }
      case "ContainerSize": {
        if (isChecked) {
          this.sldCntsize.push(item);
          // this.sldCity = [];
          // this.sldDpt = [];
          // this.sldSlCnd=[];
          this.sldCnttype = [];
          this.sldClrcd = [];
          // this.sldCntsize = [];
          // this.sldCnttype = [];
          this.sldPrc = [];
        } else {
          index = vm.sldCntsize.indexOf(item);
          vm.sldCntsize.splice(index, 1);
        }
        break;
      }
      case "ContainerType": {
        if (isChecked) {
          this.sldCnttype.push(item);
          // this.sldCity = [];
          // this.sldDpt = [];
          // this.sldSlCnd=[];
          this.sldClrcd = [];
          // this.sldCntsize = [];
          // this.sldCnttype = [];
          this.sldPrc = [];
        } else {
          index = vm.sldCnttype.indexOf(item);
          vm.sldCnttype.splice(index, 1);
        }
        break;
      }

      case "ColourCode": {
        if (isChecked) {
          this.sldClrcd.push(item);
        } else {
          index = vm.sldClrcd.indexOf(item);
          vm.sldClrcd.splice(index, 1);
        }
        break;
      }
      case "Price": {
        if (isChecked) {
          this.sldPrc.push(item);
        } else {
          index = vm.sldPrc.indexOf(item);
          vm.sldPrc.splice(index, 1);
        }
        break;
      }
    }
  }

  bindCheckBoxDetails(checkBoxType, selectedItem, checkbox) {
    switch (checkBoxType) {
      case "Country":
        // this.bindCityCheckBox(checkBoxType);
        // this.bindDepotCheckBox(checkBoxType);
        break;
      case "City":
        // this.bindDepotCheckBox(checkBoxType);
        break;
      case "Depot":
        break;
      default:
        break;
    }
  }

  bindCountCheckBox(uniquevalue, totalvalue, type) {
    let key: any;
    let list: any;
    let count: number = 0;
    let unit: any = [];
    if (type == "Depot") {
      key = "dpT_NAM";
      list = this.dptLst;
    }
    if (type == "City") {
      key = "ctY_NAM";
      list = this.cityLst;
    }
    if (type == "SaleCondition") {
      key = "sL_CNDTN_NAM";
      list = this.slcndLst;
    }
    if (type == "ContainerType") {
      key = "cntnR_TYP_CD";
      list = this.cnttypLst;
    }
    if (type == "ContainerSize") {
      key = "cntnR_SZ_CD";
      list = this.cntszLst;
    }
    if (type == "ColourCode") {
      key = "clR_CD_NM";
      list = this.clrcdLst;
    }
    // if (type == "Price") {
    //   key = "sL_PRC_NC";
    //   list = this.pceLst;
    // }

    for (let j in uniquevalue) {
      for (let i in totalvalue) {
        if (uniquevalue[j] == totalvalue[i][key]) {
          count += totalvalue[i]["avL_UNTS"];
        }
      }
      unit.push(count);
      count = 0;
    }

    for (let index = 0; index < uniquevalue.length; index++) {
      const element = uniquevalue[index];
      const unitelement = unit[index];
      // filteredDepot.push(element);

      let obj: filterValues = {
        fltNm: "",
        avlUnt: ""
      };
      obj.fltNm = element;
      obj.avlUnt = unit[index];
      list.push(obj);
    }
    unit = [];
  }

  bindDepotCheckBox(chkType) {
    let country = this.sldCnty;
    let city = this.sldCity;
    let depo = this.sldDpt;
    let containerData: any = GlobalValues.cntrDtls;
    let filteredDepot: any = [];
    this.dptLst = [];

    if (chkType == "Country") {
      let uniqueDepot: any;
      let uniqueSaleCondition: any;
      let uniqueContainerType: any;
      let uniqueCountainerSize: any;
      let uniqueColourCode: any;
      let uniquePrice: any;
      let count: number = 0;
      let unit: any = [];
      if (city.length > 0) {
        for (let index = 0; index < city.length; index++) {
          const element = city[index];
          let containerDetail = containerData.filter(x => x.ctY_NAM == element);
          const depot = containerDetail.map(data => data.dpT_NAM);
          uniqueDepot = depot.filter((x, i, a) => x && a.indexOf(x) === i);
          this.bindCountCheckBox(uniqueDepot, containerData, "Depot");

          const SaleCondition = containerDetail.map(data => data.sL_CNDTN_NAM);
          uniqueSaleCondition = SaleCondition.filter(
            (x, i, a) => x && a.indexOf(x) === i
          );
          this.bindCountCheckBox(
            uniqueSaleCondition,
            containerData,
            "SaleCondition"
          );

          const ContainerType = containerDetail.map(data => data.cntnR_TYP_CD);
          uniqueContainerType = ContainerType.filter(
            (x, i, a) => x && a.indexOf(x) === i
          );
          this.bindCountCheckBox(
            uniqueContainerType,
            containerData,
            "ContainerCode"
          );
        }
      } else {
        for (let index = 0; index < country.length; index++) {
          const element = country[index];
          let countryData = containerData.filter(x => x.cntrY_NAM == element);
          const depot = countryData.map(data => data.dpT_NAM);
          uniqueDepot = depot.filter((x, i, a) => x && a.indexOf(x) === i);
          this.bindCountCheckBox(uniqueDepot, containerData, "Depot");
        }
      }
    } else if (chkType == "City") {
      let unit: any = [];
      let count: number = 0;
      if (city.length > 0) {
        for (let index = 0; index < city.length; index++) {
          const element = city[index];
          let containerDetail = containerData.filter(x => x.ctY_NAM == element);
          const depot = containerDetail.map(data => data.dpT_NAM);
          let uniqueDepot = depot.filter((x, i, a) => x && a.indexOf(x) === i);
          this.bindCountCheckBox(uniqueDepot, containerData, "Depot");
        }
      } else {
        unit = [];
        count = 0;
        for (let index = 0; index < country.length; index++) {
          const element = country[index];
          let countryData = containerData.filter(x => x.cntrY_NAM == element);
          const depot = countryData.map(data => data.dpT_NAM);
          let uniqueDepot = depot.filter((x, i, a) => x && a.indexOf(x) === i);
          this.bindCountCheckBox(uniqueDepot, containerData, "Depot");
        }
      }
    }
  }

  // bindCityCheckBox(chkType) {
  //   let country = this.sldCnty;
  //   let city = this.sldCity;
  //   let depo = this.sldDpt;
  //   let containerData: any = GlobalValues.cntrDtls;
  //   let coutContainerData: any = GlobalValues.cntrDtls;
  //   let count: any = 0;
  //   let unit: any = [];

  //   let filteredCity: any = [];
  //   this.cityLst = [];
  //   if (country.length > 0) {
  //     for (let index = 0; index < country.length; index++) {
  //       const element = country[index];
  //       let countryData = containerData.filter(x => x.cntrY_NAM == element);
  //       const cities = countryData.map(data => data.ctY_NAM);
  //       let uniqueCity = cities.filter((x, i, a) => x && a.indexOf(x) === i);
  //       this.bindCountCheckBox(uniqueCity, containerData, "City");
  //     }
  //   } else {
  //     this.getFilter();
  //   }
  // }

  filterCase() {
    let country = this.sldCnty;
    let city = this.sldCity;
    let depo = this.sldDpt;
    if (
      (country.length == 0 && city.length == 0 && depo.length != 0) ||
      (country.length == 0 && city.length != 0 && depo.length != 0) ||
      (country.length != 0 && city.length == 0 && depo.length != 0) ||
      (country.length != 0 && city.length != 0 && depo.length != 0)
    ) {
      return "DPT";
    } else if (
      (country.length == 0 && city.length != 0 && depo.length == 0) ||
      (country.length != 0 && city.length != 0 && depo.length == 0)
    ) {
      return "CTY";
    } else if (country.length != 0 && city.length == 0 && depo.length == 0) {
      return "CNTRY";
    } else {
      return "DEFLT";
    }
  }
  //sai
  doFilter(checkBoxType, selectedItem, checkbox) {
    let country = this.sldCnty;
    let city = this.sldCity;
    let depo = this.sldDpt;
    let salecondition = this.sldSlCnd;
    let containertype = this.sldCnttype;
    let containersize = this.sldCntsize;
    let colorcode = this.sldClrcd;
    let price = this.sldPrc;

    let containerData: any = GlobalValues.cntrDtls;
    let filteredDetails: any = [];
    let currentContainerData: any = GlobalValues.currentcntrDtls;
    let priceContainerData: any;

    if (country.length != 0 && city.length == 0 && depo.length == 0) {
      this.container_detail = [];
      for (let index = 0; index < country.length; index++) {
        const element = country[index];
        filteredDetails = containerData.filter(x => x.cntrY_NAM == element);

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
        this.container_detail.sort(function (obj1, obj2) {
          return (obj1.ctY_NAM > obj2.ctY_NAM) ? 1 : ((obj2.ctY_NAM > obj1.ctY_NAM) ? -1 : 0);
        })
        // this.container_detail.sortBy('ctY_NAM');
      }
      // GlobalValues.currentcntrDtls = this.container_detail;
      // this.getFilterdata(this.container_detail, "default");
    }
    if (country.length == 0 && city.length != 0 && depo.length == 0) {
      this.container_detail = [];
      for (let index = 0; index < city.length; index++) {
        const element = city[index];
        filteredDetails = containerData.filter(x => x.ctY_NAM == element);

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
          this.container_detail.sort()

          this.container_detail.sort(function (obj1, obj2) {
            return (obj1.ctY_NAM > obj2.ctY_NAM) ? 1 : ((obj2.ctY_NAM > obj1.ctY_NAM) ? -1 : 0);
          })
        });
      }
      // GlobalValues.currentcntrDtls = this.container_detail;
      // this.getFilterdata(this.container_detail, "CTY");
    }

    if (country.length == 0 && city.length == 0 && depo.length != 0) {
      this.container_detail = [];
      for (let index = 0; index < depo.length; index++) {
        const element = depo[index];
        filteredDetails = containerData.filter(x => x.dpT_NAM == element);

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }
      // GlobalValues.currentcntrDtls = this.container_detail;
      // this.getFilterdata(this.container_detail, "DPT");
    }
    if (country.length != 0 && city.length != 0 && depo.length == 0) {
      this.container_detail = [];
      let tempcountry: any = [];
      for (let index = 0; index < country.length; index++) {
        const element = country[index];

        filteredDetails = containerData.filter(x => x.cntrY_NAM == element);

        filteredDetails.forEach(element => {
          tempcountry.push(element);
        });
      }
      for (let index = 0; index < city.length; index++) {
        const element = city[index];

        filteredDetails = tempcountry.filter(x => x.ctY_NAM == element);

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }
      // GlobalValues.currentcntrDtls = this.container_detail;
      // this.getFilterdata(this.container_detail, "CTY");
    }

    if (country.length == 0 && city.length != 0 && depo.length != 0) {
      this.container_detail = [];
      let tempcity: any = [];
      for (let index = 0; index < city.length; index++) {
        const element = city[index];

        filteredDetails = containerData.filter(x => x.ctY_NAM == element);

        filteredDetails.forEach(element => {
          tempcity.push(element);
        });
      }
      for (let index = 0; index < depo.length; index++) {
        const element = depo[index];

        filteredDetails = tempcity.filter(x => x.dpT_NAM == element);

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }
      // GlobalValues.currentcntrDtls = this.container_detail;
      // this.getFilterdata(this.container_detail, "DPT");
    }

    if (country.length != 0 && city.length == 0 && depo.length != 0) {
      this.container_detail = [];
      let tempcountry: any = [];
      for (let index = 0; index < country.length; index++) {
        const element = country[index];

        filteredDetails = containerData.filter(x => x.cntrY_NAM == element);

        filteredDetails.forEach(element => {
          tempcountry.push(element);
        });
      }
      for (let index = 0; index < depo.length; index++) {
        const element = depo[index];

        filteredDetails = tempcountry.filter(x => x.dpT_NAM == element);

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }
      // GlobalValues.currentcntrDtls = this.container_detail;
      // this.getFilterdata(this.container_detail, "DPT");
    }

    if (country.length != 0 && city.length != 0 && depo.length != 0) {
      this.container_detail = [];
      let tempcountry: any = [];
      let tempcity: any = [];
      for (let index = 0; index < country.length; index++) {
        const element = country[index];

        filteredDetails = containerData.filter(x => x.cntrY_NAM == element);

        filteredDetails.forEach(element => {
          tempcountry.push(element);
        });
      }
      for (let index = 0; index < city.length; index++) {
        const element = city[index];

        filteredDetails = tempcountry.filter(x => x.ctY_NAM == element);

        filteredDetails.forEach(element => {
          tempcity.push(element);
        });
      }
      for (let index = 0; index < depo.length; index++) {
        const element = depo[index];

        filteredDetails = tempcity.filter(x => x.dpT_NAM == element);

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }
      // GlobalValues.currentcntrDtls = this.container_detail;
      // this.getFilterdata(this.container_detail, "DPT");
    }
    if (city.length == 0 && country.length == 0 && depo.length == 0) {
      currentContainerData = GlobalValues.cntrDtls;
    } else {
      GlobalValues.currentcntrDtls = this.container_detail;
      currentContainerData = GlobalValues.currentcntrDtls;
    }
    if (
      salecondition.length != 0 &&
      containertype.length != 0 &&
      containersize.length != 0 &&
      colorcode.length != 0
    ) {
      this.container_detail = [];

      let tempsalecondition: any = [];
      let tempcontainertype: any = [];
      let tempcontainersize: any = [];
      let tempcolorcode: any = [];

      for (let index = 0; index < salecondition.length; index++) {
        const element = salecondition[index];

        filteredDetails = currentContainerData.filter(
          x => x.sL_CNDTN_NAM == element
        );

        filteredDetails.forEach(element => {
          tempsalecondition.push(element);
        });
      }
      for (let index = 0; index < containertype.length; index++) {
        const element = containertype[index];

        filteredDetails = tempsalecondition.filter(
          x => x.cntnR_TYP_CD == element
        );

        filteredDetails.forEach(element => {
          tempcontainertype.push(element);
        });
      }
      for (let index = 0; index < containersize.length; index++) {
        const element = containersize[index];

        filteredDetails = tempcontainertype.filter(
          x => x.cntnR_SZ_CD == element
        );

        filteredDetails.forEach(element => {
          tempcontainersize.push(element);
        });
      }
      for (let index = 0; index < colorcode.length; index++) {
        const element = colorcode[index];

        filteredDetails = tempcontainersize.filter(x => x.clR_CD_NM == element);

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }

      // this.getFilterdata(this.container_detail, "CLR");
    }
    if (
      salecondition.length != 0 &&
      containertype.length != 0 &&
      containersize.length != 0 &&
      colorcode.length == 0
    ) {
      this.container_detail = [];

      let tempsalecondition: any = [];
      let tempcontainertype: any = [];
      let tempcontainersize: any = [];
      let tempcolorcode: any = [];

      for (let index = 0; index < salecondition.length; index++) {
        const element = salecondition[index];

        filteredDetails = currentContainerData.filter(
          x => x.sL_CNDTN_NAM == element
        );

        filteredDetails.forEach(element => {
          tempsalecondition.push(element);
        });
      }
      for (let index = 0; index < containertype.length; index++) {
        const element = containertype[index];

        filteredDetails = tempsalecondition.filter(
          x => x.cntnR_TYP_CD == element
        );

        filteredDetails.forEach(element => {
          tempcontainertype.push(element);
        });
      }
      for (let index = 0; index < containersize.length; index++) {
        const element = containersize[index];

        filteredDetails = tempcontainertype.filter(
          x => x.cntnR_SZ_CD == element
        );

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }
      // for (let index = 0; index < colorcode.length; index++) {
      //   const element = colorcode[index];

      //   filteredDetails = tempcontainersize.filter(x => x.clR_CD_NM == element);

      //   filteredDetails.forEach(element => {
      //     this.container_detail.push(element);
      //   });
      // }

      // this.getFilterdata(this.container_detail, "SZE");
    }
    if (
      salecondition.length != 0 &&
      containertype.length != 0 &&
      containersize.length == 0 &&
      colorcode.length != 0
    ) {
      this.container_detail = [];

      let tempsalecondition: any = [];
      let tempcontainertype: any = [];
      let tempcontainersize: any = [];
      let tempcolorcode: any = [];

      for (let index = 0; index < salecondition.length; index++) {
        const element = salecondition[index];

        filteredDetails = currentContainerData.filter(
          x => x.sL_CNDTN_NAM == element
        );

        filteredDetails.forEach(element => {
          tempsalecondition.push(element);
        });
      }
      for (let index = 0; index < containertype.length; index++) {
        const element = containertype[index];

        filteredDetails = tempsalecondition.filter(
          x => x.cntnR_TYP_CD == element
        );

        filteredDetails.forEach(element => {
          tempcontainertype.push(element);
        });
      }
      // for (let index = 0; index < containersize.length; index++) {
      //   const element = containersize[index];

      //   filteredDetails = tempcontainertype.filter(x => x.cntnR_SZ_CD == element);

      //   filteredDetails.forEach(element => {
      //     tempcontainersize.push(element);
      //   });
      // }
      for (let index = 0; index < colorcode.length; index++) {
        const element = colorcode[index];

        filteredDetails = tempcontainertype.filter(x => x.clR_CD_NM == element);

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }

      // this.getFilterdata(this.container_detail, "CLR");
    }
    if (
      salecondition.length != 0 &&
      containertype.length != 0 &&
      containersize.length == 0 &&
      colorcode.length == 0
    ) {
      this.container_detail = [];

      let tempsalecondition: any = [];
      let tempcontainertype: any = [];
      let tempcontainersize: any = [];
      let tempcolorcode: any = [];

      for (let index = 0; index < salecondition.length; index++) {
        const element = salecondition[index];

        filteredDetails = currentContainerData.filter(
          x => x.sL_CNDTN_NAM == element
        );

        filteredDetails.forEach(element => {
          tempsalecondition.push(element);
        });
      }
      for (let index = 0; index < containertype.length; index++) {
        const element = containertype[index];

        filteredDetails = tempsalecondition.filter(
          x => x.cntnR_TYP_CD == element
        );

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }
      // for (let index = 0; index < containersize.length; index++) {
      //   const element = containersize[index];

      //   filteredDetails = tempcontainertype.filter(x => x.cntnR_SZ_CD == element);

      //   filteredDetails.forEach(element => {
      //     tempcontainersize.push(element);
      //   });
      // }
      // for (let index = 0; index < colorcode.length; index++) {
      //   const element = colorcode[index];

      //   filteredDetails = tempcontainersize.filter(x => x.clR_CD_NM == element);

      //   filteredDetails.forEach(element => {
      //     this.container_detail.push(element);
      //   });
      // }
      // this.getFilterdata(this.container_detail, "TYP");
    }
    if (
      salecondition.length != 0 &&
      containertype.length == 0 &&
      containersize.length != 0 &&
      colorcode.length != 0
    ) {
      this.container_detail = [];

      let tempsalecondition: any = [];
      let tempcontainertype: any = [];
      let tempcontainersize: any = [];
      let tempcolorcode: any = [];

      for (let index = 0; index < salecondition.length; index++) {
        const element = salecondition[index];

        filteredDetails = currentContainerData.filter(
          x => x.sL_CNDTN_NAM == element
        );

        filteredDetails.forEach(element => {
          tempsalecondition.push(element);
        });
      }
      // for (let index = 0; index < containertype.length; index++) {
      //   const element = containertype[index];

      //   filteredDetails = tempsalecondition.filter(x => x.cntnR_TYP_CD == element);

      //   filteredDetails.forEach(element => {
      //     tempcontainertype.push(element);
      //   });
      // }
      for (let index = 0; index < containersize.length; index++) {
        const element = containersize[index];

        filteredDetails = tempsalecondition.filter(
          x => x.cntnR_SZ_CD == element
        );

        filteredDetails.forEach(element => {
          tempcontainersize.push(element);
        });
      }
      for (let index = 0; index < colorcode.length; index++) {
        const element = colorcode[index];

        filteredDetails = tempcontainersize.filter(x => x.clR_CD_NM == element);

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }

      // this.getFilterdata(this.container_detail, "CLR");
    }
    if (
      salecondition.length != 0 &&
      containertype.length == 0 &&
      containersize.length != 0 &&
      colorcode.length == 0
    ) {
      this.container_detail = [];

      let tempsalecondition: any = [];
      let tempcontainertype: any = [];
      let tempcontainersize: any = [];
      let tempcolorcode: any = [];

      for (let index = 0; index < salecondition.length; index++) {
        const element = salecondition[index];

        filteredDetails = currentContainerData.filter(
          x => x.sL_CNDTN_NAM == element
        );

        filteredDetails.forEach(element => {
          tempsalecondition.push(element);
        });
      }
      // for (let index = 0; index < containertype.length; index++) {
      //   const element = containertype[index];

      //   filteredDetails = tempsalecondition.filter(x => x.cntnR_TYP_CD == element);

      //   filteredDetails.forEach(element => {
      //     tempcontainertype.push(element);
      //   });
      // }
      for (let index = 0; index < containersize.length; index++) {
        const element = containersize[index];

        filteredDetails = tempsalecondition.filter(
          x => x.cntnR_SZ_CD == element
        );

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }
      // for (let index = 0; index < colorcode.length; index++) {
      //   const element = colorcode[index];

      //   filteredDetails = tempcontainersize.filter(x => x.clR_CD_NM == element);

      //   filteredDetails.forEach(element => {
      //     this.container_detail.push(element);
      //   });
      // }

      // this.getFilterdata(this.container_detail, "SZE");
    }
    if (
      salecondition.length != 0 &&
      containertype.length == 0 &&
      containersize.length == 0 &&
      colorcode.length != 0
    ) {
      this.container_detail = [];

      let tempsalecondition: any = [];
      let tempcontainertype: any = [];
      let tempcontainersize: any = [];
      let tempcolorcode: any = [];

      for (let index = 0; index < salecondition.length; index++) {
        const element = salecondition[index];

        filteredDetails = currentContainerData.filter(
          x => x.sL_CNDTN_NAM == element
        );

        filteredDetails.forEach(element => {
          tempsalecondition.push(element);
        });
      }
      // for (let index = 0; index < containertype.length; index++) {
      //   const element = containertype[index];

      //   filteredDetails = tempsalecondition.filter(
      //     x => x.cntnR_TYP_CD == element
      //   );

      //   filteredDetails.forEach(element => {
      //     tempcontainertype.push(element);
      //   });
      // }
      // for (let index = 0; index < containersize.length; index++) {
      //   const element = containersize[index];

      //   filteredDetails = tempcontainertype.filter(
      //     x => x.cntnR_SZ_CD == element
      //   );

      //   filteredDetails.forEach(element => {
      //     tempcontainersize.push(element);
      //   });
      // }
      for (let index = 0; index < colorcode.length; index++) {
        const element = colorcode[index];

        filteredDetails = tempsalecondition.filter(x => x.clR_CD_NM == element);

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }

      // this.getFilterdata(this.container_detail, "CLR");
    }
    if (
      salecondition.length != 0 &&
      containertype.length == 0 &&
      containersize.length == 0 &&
      colorcode.length == 0
    ) {
      this.container_detail = [];

      let tempsalecondition: any = [];
      let tempcontainertype: any = [];
      let tempcontainersize: any = [];
      let tempcolorcode: any = [];

      for (let index = 0; index < salecondition.length; index++) {
        const element = salecondition[index];

        filteredDetails = currentContainerData.filter(
          x => x.sL_CNDTN_NAM == element
        );

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }

      // this.getFilterdata(this.container_detail, "SAL");
    }
    if (
      salecondition.length == 0 &&
      containertype.length != 0 &&
      containersize.length != 0 &&
      colorcode.length != 0
    ) {
      this.container_detail = [];

      let tempsalecondition: any = [];
      let tempcontainertype: any = [];
      let tempcontainersize: any = [];
      let tempcolorcode: any = [];

      // for (let index = 0; index < salecondition.length; index++) {
      //   const element = salecondition[index];

      //   filteredDetails = currentContainerData.filter(
      //     x => x.sL_CNDTN_NAM == element
      //   );

      //   filteredDetails.forEach(element => {
      //     tempsalecondition.push(element);
      //   });
      // }
      for (let index = 0; index < containertype.length; index++) {
        const element = containertype[index];

        filteredDetails = currentContainerData.filter(
          x => x.cntnR_TYP_CD == element
        );

        filteredDetails.forEach(element => {
          tempcontainertype.push(element);
        });
      }
      for (let index = 0; index < containersize.length; index++) {
        const element = containersize[index];

        filteredDetails = tempcontainertype.filter(
          x => x.cntnR_SZ_CD == element
        );

        filteredDetails.forEach(element => {
          tempcontainersize.push(element);
        });
      }
      for (let index = 0; index < colorcode.length; index++) {
        const element = colorcode[index];

        filteredDetails = tempcontainersize.filter(x => x.clR_CD_NM == element);

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }

      // this.getFilterdata(this.container_detail, "CLR");
    }
    if (
      salecondition.length == 0 &&
      containertype.length != 0 &&
      containersize.length == 0 &&
      colorcode.length != 0
    ) {
      this.container_detail = [];

      let tempsalecondition: any = [];
      let tempcontainertype: any = [];
      let tempcontainersize: any = [];
      let tempcolorcode: any = [];

      // for (let index = 0; index < salecondition.length; index++) {
      //   const element = salecondition[index];

      //   filteredDetails = currentContainerData.filter(
      //     x => x.sL_CNDTN_NAM == element
      //   );

      //   filteredDetails.forEach(element => {
      //     tempsalecondition.push(element);
      //   });
      // }
      for (let index = 0; index < containertype.length; index++) {
        const element = containertype[index];

        filteredDetails = currentContainerData.filter(
          x => x.cntnR_TYP_CD == element
        );

        filteredDetails.forEach(element => {
          tempcontainertype.push(element);
        });
      }
      // for (let index = 0; index < containersize.length; index++) {
      //   const element = containersize[index];

      //   filteredDetails = tempcontainertype.filter(
      //     x => x.cntnR_SZ_CD == element
      //   );

      //   filteredDetails.forEach(element => {
      //     tempcontainersize.push(element);
      //   });
      // }
      for (let index = 0; index < colorcode.length; index++) {
        const element = colorcode[index];

        filteredDetails = tempcontainertype.filter(x => x.clR_CD_NM == element);

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }

      // this.getFilterdata(this.container_detail, "CLR");
    }
    if (
      salecondition.length == 0 &&
      containertype.length != 0 &&
      containersize.length != 0 &&
      colorcode.length == 0
    ) {
      this.container_detail = [];

      let tempsalecondition: any = [];
      let tempcontainertype: any = [];
      let tempcontainersize: any = [];
      let tempcolorcode: any = [];

      // for (let index = 0; index < salecondition.length; index++) {
      //   const element = salecondition[index];

      //   filteredDetails = currentContainerData.filter(
      //     x => x.sL_CNDTN_NAM == element
      //   );

      //   filteredDetails.forEach(element => {
      //     tempsalecondition.push(element);
      //   });
      // }
      for (let index = 0; index < containertype.length; index++) {
        const element = containertype[index];

        filteredDetails = currentContainerData.filter(
          x => x.cntnR_TYP_CD == element
        );

        filteredDetails.forEach(element => {
          tempcontainertype.push(element);
        });
      }
      for (let index = 0; index < containersize.length; index++) {
        const element = containersize[index];

        filteredDetails = tempcontainertype.filter(
          x => x.cntnR_SZ_CD == element
        );

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }
      // for (let index = 0; index < colorcode.length; index++) {
      //   const element = colorcode[index];

      //   filteredDetails = tempcontainersize.filter(x => x.clR_CD_NM == element);

      //   filteredDetails.forEach(element => {
      //     this.container_detail.push(element);
      //   });
      // }

      // this.getFilterdata(this.container_detail, "SZE");
    }
    if (
      salecondition.length == 0 &&
      containertype.length == 0 &&
      containersize.length != 0 &&
      colorcode.length != 0
    ) {
      this.container_detail = [];

      let tempsalecondition: any = [];
      let tempcontainertype: any = [];
      let tempcontainersize: any = [];
      let tempcolorcode: any = [];

      // for (let index = 0; index < salecondition.length; index++) {
      //   const element = salecondition[index];

      //   filteredDetails = currentContainerData.filter(
      //     x => x.sL_CNDTN_NAM == element
      //   );

      //   filteredDetails.forEach(element => {
      //     tempsalecondition.push(element);
      //   });
      // }
      // for (let index = 0; index < containertype.length; index++) {
      //   const element = containertype[index];

      //   filteredDetails = tempsalecondition.filter(
      //     x => x.cntnR_TYP_CD == element
      //   );

      //   filteredDetails.forEach(element => {
      //     tempcontainertype.push(element);
      //   });
      // }
      for (let index = 0; index < containersize.length; index++) {
        const element = containersize[index];

        filteredDetails = currentContainerData.filter(
          x => x.cntnR_SZ_CD == element
        );

        filteredDetails.forEach(element => {
          tempcontainersize.push(element);
        });
      }
      for (let index = 0; index < colorcode.length; index++) {
        const element = colorcode[index];

        filteredDetails = tempcontainersize.filter(x => x.clR_CD_NM == element);

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }

      // this.getFilterdata(this.container_detail, "CLR");
    }
    if (
      salecondition.length == 0 &&
      containertype.length != 0 &&
      containersize.length == 0 &&
      colorcode.length == 0
    ) {
      this.container_detail = [];

      let tempsalecondition: any = [];
      let tempcontainertype: any = [];
      let tempcontainersize: any = [];
      let tempcolorcode: any = [];

      // for (let index = 0; index < salecondition.length; index++) {
      //   const element = salecondition[index];

      //   filteredDetails = currentContainerData.filter(
      //     x => x.sL_CNDTN_NAM == element
      //   );

      //   filteredDetails.forEach(element => {
      //     tempsalecondition.push(element);
      //   });
      // }
      for (let index = 0; index < containertype.length; index++) {
        const element = containertype[index];

        filteredDetails = currentContainerData.filter(
          x => x.cntnR_TYP_CD == element
        );

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }
      // for (let index = 0; index < containersize.length; index++) {
      //   const element = containersize[index];

      //   filteredDetails = tempcontainertype.filter(
      //     x => x.cntnR_SZ_CD == element
      //   );

      //   filteredDetails.forEach(element => {
      //     tempcontainersize.push(element);
      //   });
      // }
      // for (let index = 0; index < colorcode.length; index++) {
      //   const element = colorcode[index];

      //   filteredDetails = tempcontainersize.filter(x => x.clR_CD_NM == element);

      //   filteredDetails.forEach(element => {
      //     this.container_detail.push(element);
      //   });
      // }

      // this.getFilterdata(this.container_detail, "TYP");
    }
    if (
      salecondition.length == 0 &&
      containertype.length == 0 &&
      containersize.length != 0 &&
      colorcode.length == 0
    ) {
      this.container_detail = [];

      let tempsalecondition: any = [];
      let tempcontainertype: any = [];
      let tempcontainersize: any = [];
      let tempcolorcode: any = [];

      for (let index = 0; index < containersize.length; index++) {
        const element = containersize[index];

        filteredDetails = currentContainerData.filter(
          x => x.cntnR_SZ_CD == element
        );

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }

      // this.getFilterdata(this.container_detail, "SZE");
    }

    if (
      salecondition.length == 0 &&
      containertype.length == 0 &&
      containersize.length == 0 &&
      colorcode.length != 0
    ) {
      this.container_detail = [];

      let tempsalecondition: any = [];
      let tempcontainertype: any = [];
      let tempcontainersize: any = [];
      let tempcolorcode: any = [];

      for (let index = 0; index < colorcode.length; index++) {
        const element = colorcode[index];

        filteredDetails = currentContainerData.filter(
          x => x.clR_CD_NM == element
        );

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }

      // this.getFilterdata(this.container_detail, "CLR");
    }

    if (
      city.length == 0 &&
      country.length == 0 &&
      depo.length == 0 &&
      salecondition.length == 0 &&
      containertype.length == 0 &&
      containersize.length == 0 &&
      colorcode.length == 0
    ) {
      priceContainerData = GlobalValues.cntrDtls;
    } else if (city.length == 0 && country.length == 0 && depo.length == 0) {
      GlobalValues.pricecurrentcntrDtls = this.container_detail;
      priceContainerData = GlobalValues.pricecurrentcntrDtls;
    } else {
      GlobalValues.pricecurrentcntrDtls = this.container_detail;
      priceContainerData = GlobalValues.pricecurrentcntrDtls;
    }

    if (price.length != 0) {
      this.container_detail = [];
      let maxprice: any;
      let minprice: any;

      let tempsalecondition: any = [];
      let tempcontainertype: any = [];
      let tempcontainersize: any = [];
      let tempcolorcode: any = [];

      for (let index = 0; index < price.length; index++) {
        const element = price[index];

        switch (element) {
          case "0 - 1000": {
            minprice = 0;
            maxprice = 1000;
            break;
          }
          case "1001 - 1500": {
            minprice = 1001;
            maxprice = 1500;
            break;
          }
          case "1501 - 2000": {
            minprice = 1501;
            maxprice = 2000;
            break;
          }
          case "2001 - 2500": {
            minprice = 2001;
            maxprice = 2500;
            break;
          }
          case "2501 - 3000": {
            minprice = 2501;
            maxprice = 3000;
            break;
          }
          case "3001 - Above": {
            minprice = 3001;
            break;
          }
        }

        if (minprice == 3001) {
          filteredDetails = priceContainerData.filter(
            x => x.sL_PRC_NC >= minprice
          );
        } else {
          filteredDetails = priceContainerData.filter(
            x => x.sL_PRC_NC >= minprice && x.sL_PRC_NC <= maxprice
          );
        }

        filteredDetails.forEach(element => {
          this.container_detail.push(element);
        });
      }

      // this.getFilterdata(this.container_detail, "CLR");
    }

    GlobalValues.currentcntrDtls = this.container_detail;
    this.getFilterdata(this.container_detail, checkBoxType);
  }

  clearCheckBoxState(checkBoxType, selectedItem, checkbox) {
    const vm: any = this;
    let containerData: any = GlobalValues.cntrDtls;
    let maxprice: any;
    let minprice: any;
    let country = this.sldCnty;
    let city = this.sldCity;
    let depo = this.sldDpt;
    let salecondition = this.sldSlCnd;
    let containertype = this.sldCnttype;
    let containersize = this.sldCntsize;
    let colorcode = this.sldClrcd;
    let price = this.sldPrc;

    if (checkBoxType == "Country") {
      for (let index = 0; index < containerData.length; index++) {
        const element = containerData[index];
        let countryName: any = element.cntrY_NAM;
        if (countryName == selectedItem) {
          let cityName = element.ctY_NAM;
          let depotName = element.dpT_NAM;
          let colourCode = element.clR_CD_NM;
          let saleCondition: any = element.sL_CNDTN_NAM;
          let containerType = element.cntnR_TYP_CD;
          let containerSize = element.cntnR_SZ_CD;
          let colorCode = element.clR_CD_NM;
          let price = element.sL_PRC_NC;
          if (vm.sldCity.length > 0) {
            index = vm.sldCity.indexOf(cityName);
            vm.sldCity.splice(index, 1);
          }
          if (vm.sldDpt.length > 0) {
            index = vm.sldDpt.indexOf(depotName);
            vm.sldDpt.splice(index, 1);
          }
          if (vm.sldClrcd.length > 0) {
            index = vm.sldClrcd.indexOf(colourCode);
            vm.sldClrcd.splice(index, 1);
          }
          if (vm.sldSlCnd.length > 0) {
            index = vm.sldSlCnd.indexOf(saleCondition);
            vm.sldSlCnd.splice(index, 1);
          }

          if (vm.sldCnttype.length > 0) {
            index = vm.sldCnttype.indexOf(containerType);
            vm.sldCnttype.splice(index, 1);
          }
          if (vm.sldCntsize.length > 0) {
            index = vm.sldCntsize.indexOf(containerSize);
            vm.sldCntsize.splice(index, 1);
          }
          if (vm.sldClrcd.length > 0) {
            index = vm.sldClrcd.indexOf(colorCode);
            vm.sldClrcd.splice(index, 1);
          }
          if (vm.sldPrc.length > 0) {
            if (price >= 0 && price <= 1000) {
              index = vm.sldPrc.indexOf("0 - 1000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1001 - 1500");
            }

            if (price >= 1001 && price <= 1500) {
              index = vm.sldPrc.indexOf("1001 - 1500");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1001 - 1500");
            }
            if (price >= 1501 && price <= 2000) {
              index = vm.sldPrc.indexOf("1501 - 2000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1501 - 2000");
            }
            if (price >= 2001 && price <= 2500) {
              index = vm.sldPrc.indexOf("2001 - 2500");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2001 - 2500");
            }
            if (price >= 2501 && price <= 3000) {
              index = vm.sldPrc.indexOf("2501 - 3000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2501 - 3000");
            }
            if (price >= 3001) {
              index = vm.sldPrc.indexOf("3000 - Above");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2501 - 3000");
            }
          }
        }
      }
    }

    if (checkBoxType == "City") {
      for (let index = 0; index < containerData.length; index++) {
        const element = containerData[index];
        let cityName: any = element.ctY_NAM;
        if (cityName == selectedItem) {
          let depotName = element.dpT_NAM;
          let colourCode = element.clR_CD_NM;
          let saleCondition: any = element.sL_CNDTN_NAM;
          let containerType = element.cntnR_TYP_CD;
          let containerSize = element.cntnR_SZ_CD;
          let colorCode = element.clR_CD_NM;
          let price = element.sL_PRC_NC;
          if (vm.sldDpt.length > 0) {
            index = vm.sldDpt.indexOf(depotName);
            vm.sldDpt.splice(index, 1);
          }
          if (vm.sldClrcd.length > 0) {
            index = vm.sldClrcd.indexOf(colourCode);
            vm.sldClrcd.splice(index, 1);
          }
          if (vm.sldSlCnd.length > 0) {
            index = vm.sldSlCnd.indexOf(saleCondition);
            vm.sldSlCnd.splice(index, 1);
          }

          if (vm.sldCnttype.length > 0) {
            index = vm.sldCnttype.indexOf(containerType);
            vm.sldCnttype.splice(index, 1);
          }
          if (vm.sldCntsize.length > 0) {
            index = vm.sldCntsize.indexOf(containerSize);
            vm.sldCntsize.splice(index, 1);
          }
          if (vm.sldClrcd.length > 0) {
            index = vm.sldClrcd.indexOf(colorCode);
            vm.sldClrcd.splice(index, 1);
          }
          if (vm.sldPrc.length > 0) {
            if (price >= 0 && price <= 1000) {
              index = vm.sldPrc.indexOf("0 - 1000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1001 - 1500");
            }

            if (price >= 1001 && price <= 1500) {
              index = vm.sldPrc.indexOf("1001 - 1500");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1001 - 1500");
            }
            if (price >= 1501 && price <= 2000) {
              index = vm.sldPrc.indexOf("1501 - 2000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1501 - 2000");
            }
            if (price >= 2001 && price <= 2500) {
              index = vm.sldPrc.indexOf("2001 - 2500");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2001 - 2500");
            }
            if (price >= 2501 && price <= 3000) {
              index = vm.sldPrc.indexOf("2501 - 3000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2501 - 3000");
            }
            if (price >= 3001) {
              index = vm.sldPrc.indexOf("3000 - Above");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2501 - 3000");
            }
          }
        }
      }
    }
    if (checkBoxType == "Depot") {
      for (let index = 0; index < containerData.length; index++) {
        const element = containerData[index];
        let depot: any = element.dpT_NAM;

        if (depot == selectedItem) {
          let saleCondition: any = element.sL_CNDTN_NAM;
          let containerType = element.cntnR_TYP_CD;
          let containerSize = element.cntnR_SZ_CD;
          let colorCode = element.clR_CD_NM;
          let price = element.sL_PRC_NC;
          if (vm.sldSlCnd.length > 0) {
            index = vm.sldSlCnd.indexOf(saleCondition);
            vm.sldSlCnd.splice(index, 1);
          }
          if (vm.sldCnttype.length > 0) {
            index = vm.sldCnttype.indexOf(containerType);
            vm.sldCnttype.splice(index, 1);
          }
          if (vm.sldCntsize.length > 0) {
            index = vm.sldCntsize.indexOf(containerSize);
            vm.sldCntsize.splice(index, 1);
          }
          if (vm.sldClrcd.length > 0) {
            index = vm.sldClrcd.indexOf(colorCode);
            vm.sldClrcd.splice(index, 1);
          }
          if (vm.sldPrc.length > 0) {
            if (price >= 0 && price <= 1000) {
              index = vm.sldPrc.indexOf("0 - 1000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1001 - 1500");
            }

            if (price >= 1001 && price <= 1500) {
              index = vm.sldPrc.indexOf("1001 - 1500");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1001 - 1500");
            }
            if (price >= 1501 && price <= 2000) {
              index = vm.sldPrc.indexOf("1501 - 2000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1501 - 2000");
            }
            if (price >= 2001 && price <= 2500) {
              index = vm.sldPrc.indexOf("2001 - 2500");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2001 - 2500");
            }
            if (price >= 2501 && price <= 3000) {
              index = vm.sldPrc.indexOf("2501 - 3000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2501 - 3000");
            }
            if (price >= 3001) {
              index = vm.sldPrc.indexOf("3000 - Above");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2501 - 3000");
            }
          }
        }
      }
    }
    if (checkBoxType == "SaleCondition") {
      for (let index = 0; index < containerData.length; index++) {
        const element = containerData[index];
        let saleCondition: any = element.sL_CNDTN_NAM;
        if (saleCondition == selectedItem) {
          let containerType = element.cntnR_TYP_CD;
          let containerSize = element.cntnR_SZ_CD;
          let colorCode = element.clR_CD_NM;
          let price = element.sL_PRC_NC;
          if (vm.sldCnttype.length > 0) {
            index = vm.sldCnttype.indexOf(containerType);
            vm.sldCnttype.splice(index, 1);
          }
          if (vm.sldCntsize.length > 0) {
            index = vm.sldCntsize.indexOf(containerSize);
            vm.sldCntsize.splice(index, 1);
          }
          if (vm.sldClrcd.length > 0) {
            index = vm.sldClrcd.indexOf(colorCode);
            vm.sldClrcd.splice(index, 1);
          }
          if (vm.sldPrc.length > 0) {
            if (price >= 0 && price <= 1000) {
              index = vm.sldPrc.indexOf("0 - 1000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1001 - 1500");
            }

            if (price >= 1001 && price <= 1500) {
              index = vm.sldPrc.indexOf("1001 - 1500");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1001 - 1500");
            }
            if (price >= 1501 && price <= 2000) {
              index = vm.sldPrc.indexOf("1501 - 2000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1501 - 2000");
            }
            if (price >= 2001 && price <= 2500) {
              index = vm.sldPrc.indexOf("2001 - 2500");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2001 - 2500");
            }
            if (price >= 2501 && price <= 3000) {
              index = vm.sldPrc.indexOf("2501 - 3000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2501 - 3000");
            }
            if (price >= 3001) {
              index = vm.sldPrc.indexOf("3000 - Above");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2501 - 3000");
            }
          }
        }
      }
    }
    if (checkBoxType == "ContainerSize") {
      for (let index = 0; index < containerData.length; index++) {
        const element = containerData[index];
        let containerSize = element.cntnR_SZ_CD;
        if (containerSize == selectedItem) {
          let colorCode = element.clR_CD_NM;
          let price = element.sL_PRC_NC;
          let containerType = element.cntnR_TYP_CD;

          if (vm.sldCnttype.length > 0) {
            index = vm.sldCnttype.indexOf(containerType);
            vm.sldCnttype.splice(index, 1);
          }

          if (vm.sldClrcd.length > 0) {
            index = vm.sldClrcd.indexOf(colorCode);
            vm.sldClrcd.splice(index, 1);
          }
          if (vm.sldPrc.length > 0) {
            if (price >= 0 && price <= 1000) {
              index = vm.sldPrc.indexOf("0 - 1000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1001 - 1500");
            }

            if (price >= 1001 && price <= 1500) {
              index = vm.sldPrc.indexOf("1001 - 1500");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1001 - 1500");
            }
            if (price >= 1501 && price <= 2000) {
              index = vm.sldPrc.indexOf("1501 - 2000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1501 - 2000");
            }
            if (price >= 2001 && price <= 2500) {
              index = vm.sldPrc.indexOf("2001 - 2500");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2001 - 2500");
            }
            if (price >= 2501 && price <= 3000) {
              index = vm.sldPrc.indexOf("2501 - 3000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2501 - 3000");
            }
            if (price >= 3001) {
              index = vm.sldPrc.indexOf("3000 - Above");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2501 - 3000");
            }
          }
        }
      }
    }
    if (checkBoxType == "ContainerType") {
      for (let index = 0; index < containerData.length; index++) {
        const element = containerData[index];
        let containerType = element.cntnR_TYP_CD;
        if (containerType == selectedItem) {
          // let containerSize = element.cntnR_SZ_CD;
          let colorCode = element.clR_CD_NM;
          let price = element.sL_PRC_NC;
          // if (vm.sldCntsize.length > 0) {
          //   index = vm.sldCntsize.indexOf(containerSize);
          //   vm.sldCntsize.splice(index, 1);
          // }
          if (vm.sldClrcd.length > 0) {
            index = vm.sldClrcd.indexOf(colorCode);
            vm.sldClrcd.splice(index, 1);
          }
          if (vm.sldPrc.length > 0) {
            if (price >= 0 && price <= 1000) {
              index = vm.sldPrc.indexOf("0 - 1000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1001 - 1500");
            }

            if (price >= 1001 && price <= 1500) {
              index = vm.sldPrc.indexOf("1001 - 1500");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1001 - 1500");
            }
            if (price >= 1501 && price <= 2000) {
              index = vm.sldPrc.indexOf("1501 - 2000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1501 - 2000");
            }
            if (price >= 2001 && price <= 2500) {
              index = vm.sldPrc.indexOf("2001 - 2500");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2001 - 2500");
            }
            if (price >= 2501 && price <= 3000) {
              index = vm.sldPrc.indexOf("2501 - 3000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2501 - 3000");
            }
            if (price >= 3001) {
              index = vm.sldPrc.indexOf("3000 - Above");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2501 - 3000");
            }
          }
        }
      }
    }

    if (checkBoxType == "ColourCode") {
      for (let index = 0; index < containerData.length; index++) {
        const element = containerData[index];
        let colourCode = element.clR_CD_NM;
        if (colourCode == selectedItem) {
          let price = element.sL_PRC_NC;
          if (vm.sldPrc.length > 0) {
            if (price >= 0 && price <= 1000) {
              index = vm.sldPrc.indexOf("0 - 1000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1001 - 1500");
            }

            if (price >= 1001 && price <= 1500) {
              index = vm.sldPrc.indexOf("1001 - 1500");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1001 - 1500");
            }
            if (price >= 1501 && price <= 2000) {
              index = vm.sldPrc.indexOf("1501 - 2000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("1501 - 2000");
            }
            if (price >= 2001 && price <= 2500) {
              index = vm.sldPrc.indexOf("2001 - 2500");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2001 - 2500");
            }
            if (price >= 2501 && price <= 3000) {
              index = vm.sldPrc.indexOf("2501 - 3000");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2501 - 3000");
            }
            if (price >= 3001) {
              index = vm.sldPrc.indexOf("3000 - Above");
              vm.sldPrc.splice(index, 1);
              // this.Priceval.push("2501 - 3000");
            }
          }
        }
      }
    }
    if (
      country.length == 0 &&
      city.length == 0 &&
      depo.length == 0 &&
      salecondition.length == 0 &&
      containertype.length == 0 &&
      containersize.length == 0 &&
      colorcode.length == 0 &&
      price.length == 0
    ) {
      this.Priceval = [
        "0 - 1000",
        "1001 - 1500",
        "1501 - 2000",
        "2001 - 2500",
        "2501 - 3000",
        "3001 - Above"
      ];
    }

  }
  UndoCheckBoxDetails(checkBoxType, selectedItem, checkbox) {
    let country = this.sldCnty;
    let city = this.sldCity;
    let depo = this.sldDpt;
    let salecondition = this.sldSlCnd;
    let containertype = this.sldCnttype;
    let containersize = this.sldCntsize;
    let colorcode = this.sldClrcd;
    let price = this.sldPrc;

    this.clearCheckBoxState(checkBoxType, selectedItem, checkbox);

    if (
      country.length == 0 &&
      city.length == 0 &&
      depo.length == 0 &&
      salecondition.length == 0 &&
      containertype.length == 0 &&
      containersize.length == 0 &&
      colorcode.length == 0 &&
      price.length == 0
    ) {
      this.getFilter();
    }
    // else {
    //   this.bindCheckBoxDetails(checkBoxType, selectedItem, checkbox);
    // }
  }

  //CheckBoxFunction

  //tradecustomer checkbox
  onSearchChange(searchValue : string ) {  

    if(!searchValue){
  this.customer=this.customerBind;
  } // when nothing has typed
  this.customer=this.customerBind;
  this.customer = Object.assign([], this.customer).filter(
    customer => customer.cstmR_NAM.toLowerCase().indexOf(searchValue.toLowerCase()) > -1
  )
  }
  slctCstmrCkBox(checkBoxType, selectedItem, checkbox, cstmr) {
  this.spinnerService.show();
    
    this.clearfilter();
    localStorage.removeItem("storedFilter");
   // this.loading = true;
    let isChecked = checkbox.checked;
    if (isChecked) {
          localStorage.setItem(
        'customer',
        JSON.stringify({ cstmrid: selectedItem ,dscntAmnt:cstmr['dscnT_AMNT']}));

      this.sldCstmr = cstmr;
      this.getContainers(selectedItem);
    } else {
      this.sldCstmr = [];
      localStorage.removeItem("customer");
      this.getContainers("1111");
      this.info="Please select the customer filter to list the containers";
    }
    for (var i = 0; i < this.customer.length; i++) {
      if (this.customer[i].cstmR_ID != selectedItem) {
        this.customer[i].selected = false;
      } else {
        this.customer[i].selected = true;
      }
    }

    for (var i = 0; i < this.customerBind.length; i++) {
      if (this.customerBind[i].cstmR_ID != selectedItem) {
        this.customerBind[i].selected = false;
      } else {
        this.customerBind[i].selected = true;
      }
    }


   // this.filterCheckBoxDetail(checkBoxType, selectedItem, checkbox);

  

    //this.spinnerService.hide();

  }
 
  slectCkBox(checkBoxType, selectedItem, checkbox) {
    let isChecked = checkbox.checked;
    this.filterCheckBoxDetail(checkBoxType, selectedItem, checkbox);

    if (isChecked) {
      // this.bindCheckBoxDetails(checkBoxType, selectedItem, checkbox);
    } else {
      this.UndoCheckBoxDetails(checkBoxType, selectedItem, checkbox);
      // this.clearCheckBoxState(checkBoxType, selectedItem, checkbox)
    }

    this.doFilter(checkBoxType, selectedItem, checkbox);
    if (this.container_detail.length==0){
      this.info="No Containers Available";
    }
    this.container_detail.sort(function (a, b) {

      var a_cntrY_NAM = a.cntrY_NAM;
      var b_cntrY_NAM = b.cntrY_NAM;
      var a_ctY_NAM = a.ctY_NAM;
      var b_ctY_NAM = b.ctY_NAM;
      var a_cntnR_SZ_CD = a.cntnR_SZ_CD;
      var b_cntnR_SZ_CD = b.cntnR_SZ_CD;
      var a_cntnR_TYP_CD = a.cntnR_TYP_CD;
      var b_cntnR_TYP_CD = b.cntnR_TYP_CD;
      var a_clR_CD_NM = a.clR_CD_NM;
      var b_clR_CD_NM = b.clR_CD_NM;

      if (a_cntrY_NAM < b_cntrY_NAM) {
        return -1;
      }
      else if (a_cntrY_NAM > b_cntrY_NAM) {
        return 1;
      }
      else {
        if (a_ctY_NAM < b_ctY_NAM) {
          return -1;
        }
        else if (a_ctY_NAM > b_ctY_NAM) {
          return 1;
        }
        else {
          if (a_cntnR_SZ_CD < b_cntnR_SZ_CD) {
            return -1;
          }
          else if (a_cntnR_SZ_CD > b_cntnR_SZ_CD) {
            return 1;
          }
          else {
            if (a_cntnR_TYP_CD < b_cntnR_TYP_CD) {
              return -1;
            }
            else if (a_cntnR_TYP_CD > b_cntnR_TYP_CD) {
              return 1;
            }
            else {
              if (a_clR_CD_NM < b_clR_CD_NM) {
                return -1;
              }
              else if (a_clR_CD_NM > b_clR_CD_NM) {
                return 1;
              }
            }
          }
        }

      }
    })
  }

  DrillDownFilter(title: string) {
    const vm: any = this;
    let containerData: any = GlobalValues.cntrDtls;
    let contryFilter: any;

    if (
      vm.sldCnty.length != 0 &&
      vm.sldCity.length == 0 &&
      vm.sldDpt.length == 0 &&
      title == "Country"
    ) {
      vm.fldCnty = [];
      vm.sldCnty.forEach(function (value) {
        contryFilter = containerData.filter(x => x.cntrY_NAM == value);
        contryFilter.forEach(element => {
          vm.fldCnty.push(element);
        });
      });
      this.fldCnty = this.fldCnty.filter(function (item, i, ar) {
        return ar.indexOf(item) === i;
      });
      vm.filtergetContainers("Country", this.fldCnty);
    }

    if (
      vm.sldCnty.length == 0 &&
      vm.sldCity.length != 0 &&
      vm.sldDpt.length == 0 &&
      title == "City"
    ) {
      vm.fldCity = [];
      vm.sldCity.forEach(function (value) {
        contryFilter = containerData.filter(x => x.ctY_NAM == value);
        contryFilter.forEach(element => {
          vm.fldCity.push(element);
        });
      });
      this.fldCity = this.fldCity.filter(function (item, i, ar) {
        return ar.indexOf(item) === i;
      });
      vm.filtergetContainers("City", this.fldCity);
    }

    if (
      vm.sldCnty.length != 0 &&
      vm.sldCity.length != 0 &&
      vm.sldDpt.length == 0 &&
      title == "City"
    ) {
      vm.fldCity = [];
      vm.sldCity.forEach(function (value) {
        contryFilter = vm.fldCnty.filter(x => x.ctY_NAM == value);
        contryFilter.forEach(element => {
          vm.fldCity.push(element);
        });
      });
      this.fldCity = this.fldCity.filter(function (item, i, ar) {
        return ar.indexOf(item) === i;
      });
      vm.filtergetContainers("City", this.fldCity);
    }

    if (
      vm.sldCnty.length == 0 &&
      vm.sldCity.length == 0 &&
      vm.sldDpt.length != 0 &&
      title == "Depot"
    ) {
      this.fldDpt = [];
      vm.sldDpt.forEach(function (value) {
        contryFilter = containerData.filter(x => x.dpT_NAM == value);
        contryFilter.forEach(element => {
          vm.fldDpt.push(element);
        });
      });
      this.fldDpt = this.fldDpt.filter(function (item, i, ar) {
        return ar.indexOf(item) === i;
      });
      vm.filtergetContainers("Depot", this.fldDpt);
    }
    if (
      vm.sldCnty.length == 0 &&
      vm.sldCity.length != 0 &&
      vm.sldDpt.length != 0 &&
      title == "Depot"
    ) {
      vm.fldDpt = [];
      vm.sldDpt.forEach(function (value) {
        contryFilter = vm.fldCity.filter(x => x.dpT_NAM == value);
        contryFilter.forEach(element => {
          vm.fldDpt.push(element);
        });
      });
      this.fldDpt = this.fldDpt.filter(function (item, i, ar) {
        return ar.indexOf(item) === i;
      });
      vm.filtergetContainers("Depot", this.fldDpt);
    }
  }

  showmore(title, option) {
    switch (title) {
      case "Customer": {
        this.cstmrshowmorecount = option;
        this.cstmrshowstatus = false;
        break;
      }
      case "Country": {
        this.cntyshowmorecount = option;
        this.cntyshowstatus = false;
        break;
      }
      case "City": {
        this.cityshowmorecount = option;
        this.cityshowstatus = false;
        break;
      }
      case "Depot": {
        this.dptshowmorecount = option;
        this.dptshowstatus = false;
        break;
      }
      case "Sale Condition": {
        this.slcndshowmorecount = option;
        this.slcndshowstatus = false;
        break;
      }
      case "Container Type": {
        this.cnttypshowmorecount = option;
        this.cnttypshowstatus = false;
        break;
      }
      case "Container Size": {
        this.cntszshowmorecount = option;
        this.cntszshowstatus = false;
        break;
      }
      case "Colour Code": {
        this.cntcdshowmorecount = option;
        this.cntcdshowstatus = false;
        break;
      }
      case "Price": {
        this.prcshowmorecount = option;
        this.prceshowstatus = false;
        break;
      }
    }
  }
  showless(title) {
    switch (title) {
      case "Customer": {
        this.cstmrshowmorecount = 2;
        this.cstmrshowstatus = true;
        break;
      }
      case "Country": {
        this.cntyshowmorecount = 2;
        this.cntyshowstatus = true;
        break;
      }
      case "City": {
        this.cityshowmorecount = 2;
        this.cityshowstatus = true;
        break;
      }
      case "Depot": {
        this.dptshowmorecount = 2;
        this.dptshowstatus = true;
        break;
      }
      case "Sale Condition": {
        this.slcndshowmorecount = 2;
        this.slcndshowstatus = true;
        break;
      }
      case "Container Type": {
        this.cnttypshowmorecount = 2;
        this.cnttypshowstatus = true;
        break;
      }
      case "Container Size": {
        this.cntszshowmorecount = 2;
        this.cntszshowstatus = true;
        break;
      }
      case "Colour Code": {
        this.cntcdshowmorecount = 2;
        this.cntcdshowstatus = true;
        break;
      }
      case "Price": {
        this.prcshowmorecount = 2;
        this.prceshowstatus = true;
        break;
      }
    }
  }

  clearfilter() {
    const vm = this;

    vm.sldCity = [];
    vm.sldCnty = [];
    vm.sldDpt = [];
    vm.sldSlCnd = [];
    vm.sldCnttype = [];
    vm.sldCntsize = [];
    vm.sldClrcd = [];
    vm.sldPrc = [];

    vm.fldCity = [];
    vm.fldCnty = [];
    vm.fldDpt = [];
    this.Priceval = [
      "0 - 1000",
      "1001 - 1500",
      "1501 - 2000",
      "2001 - 2500",
      "2501 - 3000",
      "3001 - Above"
    ];

   // vm.getFilter();
    vm.selectedfilter = [];
    this.container_detail=GlobalValues.cntrDtls;
  }

  sortfilter(sortfilter: string, event) {
    this.sortfilterlist = sortfilter;

    if (sortfilter == "Grade New") {
      this.orderbyststus = "NEW";
    } else if (sortfilter == "Grade Used") {
      this.orderbyststus = "USED";
    } else if (sortfilter == "Size low-high") {
      this.orderby = "cntnR_SZ_CD";
      this.orderstatus = false;
      this.orderbyststus = null;
    } else if (sortfilter == "Size high-low") {
      this.orderby = "cntnR_SZ_CD";
      this.orderstatus = true;
      this.orderbyststus = null;
    }
  }

  public binddetail(val: any) {
    let storedFilter = {
      sldCnty: this.sldCnty,
      sldCity: this.sldCity,
      sldDpt: this.sldDpt,
      sldSlCnd: this.sldSlCnd,
      sldCnttype: this.sldCnttype,
      sldCntsize: this.sldCntsize,
      sldClrcd: this.sldClrcd,
      sldPrc: this.sldPrc,
      cntyLst: this.cntyLst,
      cityLst: this.cityLst,
      dptLst: this.dptLst,
      slcndLst: this.slcndLst,
      cnttypLst: this.cnttypLst,
      cntszLst: this.cntszLst,
      clrcdLst: this.clrcdLst,
      pceLst: this.pceLst
    };
    localStorage.removeItem("viewDetail");
    localStorage.setItem("viewDetail", JSON.stringify(val));
    localStorage.setItem("storedFilter", JSON.stringify(storedFilter));
    // GlobalValues.viewDetail=val;
  }

  getFilter() {
    this.loading = false;
    this.container_detail = GlobalValues.cntrDtls;
   // this.cstmrLst =[];
    this.cntyLst = [];
    this.cityLst = [];
    this.dptLst = [];
    this.slcndLst = [];
    this.cnttypLst = [];
    this.cntszLst = [];
    this.clrcdLst = [];
    this.pceLst = [];

    //Country

    let val: any;
    let count: number = 0;
    val = null;
    this.name = [];
    this.unit = [];
    for (let i in this.container_detail) {
      val = this.container_detail[i]["cntrY_NAM"];
      this.name.push(val);
    }
    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    this.name = this.name.sort();

    for (let j in this.name) {
      for (let i in this.container_detail) {
        if (this.name[j] == this.container_detail[i]["cntrY_NAM"]) {
          count += this.container_detail[i]["avL_UNTS"];
        }
      }
      this.unit.push(count);
      count = 0;
    }

    for (let i in this.name) {
      let obj: filterValues = {
        fltNm: "",
        avlUnt: ""
      };
      obj.fltNm = this.name[i];
      obj.avlUnt = this.unit[i];
      this.cntyLst.push(obj);
    }

    //City
    val = null;
    count = 0;
    this.name = [];
    this.unit = [];

    for (let i in this.container_detail) {
      val = this.container_detail[i]["ctY_NAM"];
      this.name.push(val);
    }
    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    this.name = this.name.sort();

    for (let j in this.name) {
      for (let i in this.container_detail) {
        if (this.name[j] == this.container_detail[i]["ctY_NAM"]) {
          count += this.container_detail[i]["avL_UNTS"];
        }
      }
      this.unit.push(count);
      count = 0;
    }

    for (let i in this.name) {
      let obj: filterValues = {
        fltNm: "",
        avlUnt: ""
      };
      obj.fltNm = this.name[i];
      obj.avlUnt = this.unit[i];
      this.cityLst.push(obj);
    }

    //Deopt
    val = null;
    count = 0;
    this.name = [];
    this.unit = [];

    for (let i in this.container_detail) {
      val = this.container_detail[i]["dpT_NAM"];
      this.name.push(val);
    }
    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    this.name = this.name.sort();
    for (let j in this.name) {
      for (let i in this.container_detail) {
        if (this.name[j] == this.container_detail[i]["dpT_NAM"]) {
          count += this.container_detail[i]["avL_UNTS"];
        }
      }
      this.unit.push(count);
      count = 0;
    }

    for (let i in this.name) {
      let obj: filterValues = {
        fltNm: "",
        avlUnt: ""
      };
      obj.fltNm = this.name[i];
      obj.avlUnt = this.unit[i];
      this.dptLst.push(obj);
    }

    //SaleCondition
    val = null;
    count = 0;
    this.name = [];
    this.unit = [];

    for (let i in this.container_detail) {
      val = this.container_detail[i]["sL_CNDTN_NAM"];
      this.name.push(val);
    }
    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    this.name = this.name.sort();

    for (let j in this.name) {
      for (let i in this.container_detail) {
        if (this.name[j] == this.container_detail[i]["sL_CNDTN_NAM"]) {
          count += this.container_detail[i]["avL_UNTS"];
        }
      }
      this.unit.push(count);
      count = 0;
    }

    for (let i in this.name) {
      let obj: filterValues = {
        fltNm: "",
        avlUnt: ""
      };
      obj.fltNm = this.name[i];
      obj.avlUnt = this.unit[i];
      this.slcndLst.push(obj);
    }

    //Container Type
    val = null;
    count = 0;
    this.name = [];
    this.unit = [];

    for (let i in this.container_detail) {
      val = this.container_detail[i]["cntnR_TYP_CD"];
      this.name.push(val);
    }
    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    this.name = this.name.sort();

    for (let j in this.name) {
      for (let i in this.container_detail) {
        if (this.name[j] == this.container_detail[i]["cntnR_TYP_CD"]) {
          count += this.container_detail[i]["avL_UNTS"];
        }
      }
      this.unit.push(count);
      count = 0;
    }

    for (let i in this.name) {
      let obj: filterValues = {
        fltNm: "",
        avlUnt: ""
      };
      obj.fltNm = this.name[i];
      obj.avlUnt = this.unit[i];
      this.cnttypLst.push(obj);
    }

    //Container Size
    val = null;
    count = 0;
    this.name = [];
    this.unit = [];

    for (let i in this.container_detail) {
      val = this.container_detail[i]["cntnR_SZ_CD"];
      this.name.push(val);
    }
    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    this.name = this.name.sort();

    for (let j in this.name) {
      for (let i in this.container_detail) {
        if (this.name[j] == this.container_detail[i]["cntnR_SZ_CD"]) {
          count += this.container_detail[i]["avL_UNTS"];
        }
      }
      this.unit.push(count);
      count = 0;
    }

    for (let i in this.name) {
      let obj: filterValues = {
        fltNm: "",
        avlUnt: ""
      };
      obj.fltNm = this.name[i];
      obj.avlUnt = this.unit[i];
      this.cntszLst.push(obj);
    }

    //Color code
    val = null;
    count = 0;
    this.name = [];
    this.unit = [];

    for (let i in this.container_detail) {
      val = this.container_detail[i]["clR_CD_NM"];
      this.name.push(val);
    }
    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    this.name = this.name.sort();

    for (let j in this.name) {
      for (let i in this.container_detail) {
        if (this.name[j] == this.container_detail[i]["clR_CD_NM"]) {
          count += this.container_detail[i]["avL_UNTS"];
        }
      }
      this.unit.push(count);
      count = 0;
    }

    for (let i in this.name) {
      let obj: filterValues = {
        fltNm: "",
        avlUnt: ""
      };
      obj.fltNm = this.name[i];
      obj.avlUnt = this.unit[i];
      this.clrcdLst.push(obj);
    }

    //Price
    val = null;
    count = 0;
    this.name = [];
    this.unit = [];

    for (let i in this.container_detail) {
      val = this.container_detail[i]["sL_PRC_NC"];
      this.name.push(val);
    }

    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    // let priceval = this.name;
    // this.priceFilter(priceval);
    // this.Priceval = this.priceFilter(priceval);

    this.name = this.name.sort();

    let index = this.name.indexOf(0);
    this.name.splice(index, 1);

    for (let j in this.name) {
      for (let i in this.container_detail) {
        if (this.name[j] == this.container_detail[i]["sL_PRC_NC"]) {
          count += this.container_detail[i]["avL_UNTS"];
        }
      }
      // if (this.name[j] >= 0 && this.name[j] <= 1000)
      //   this.Pricecount[0].push(count);
      // count = 0;
    }

    // for (let i in this.name) {
    //   let obj: filterValues = {
    //     fltNm: "",
    //     avlUnt: ""
    //   };
    //   obj.fltNm = this.name[i];
    //   obj.avlUnt = this.unit[i];
    //   this.pceLst.push(obj);
    // }
    this.number_container = this.container_detail.length;
    GlobalValues.currentcntrDtls = this.container_detail;

  }

  filtergetContainers(title, data: Array<any>) {
    this.slcndLst = [];
    this.cnttypLst = [];
    this.cntszLst = [];
    this.clrcdLst = [];
    this.pceLst = [];
    if (title == "Country") {
      this.cityLst = [];
      this.dptLst = [];
      this.slcndLst = [];
      this.cnttypLst = [];
      this.cntszLst = [];
      this.clrcdLst = [];
      this.pceLst = [];
    }

    let val: any;
    let count: number = 0;
    this.container_detail = data;
    this.name = [];
    this.unit = [];

    //City
    // if(this.sldCity.length != 0){}
    val = null;
    count = 0;
    this.name = [];
    this.unit = [];

    // if (title != "City") {
    for (let i in this.container_detail) {
      val = this.container_detail[i]["ctY_NAM"];
      this.name.push(val);
    }
    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    this.name = this.name.sort();

    for (let j in this.name) {
      for (let i in this.container_detail) {
        if (this.name[j] == this.container_detail[i]["ctY_NAM"]) {
          count += this.container_detail[i]["avL_UNTS"];
        }
      }
      this.unit.push(count);
      count = 0;
    }
    if (this.sldCity.length == 0) {
      for (let i in this.name) {
        let obj: filterValues = {
          fltNm: "",
          avlUnt: ""
        };
        obj.fltNm = this.name[i];
        obj.avlUnt = this.unit[i];
        this.cityLst.push(obj);
      }
    }
    if (this.sldCity.length == 0) {
      this.cityLst = [];
      for (let i in this.name) {
        let obj: filterValues = {
          fltNm: "",
          avlUnt: ""
        };
        obj.fltNm = this.name[i];
        obj.avlUnt = this.unit[i];
        this.cityLst.push(obj);
      }
    }

    //Deopt
    val = null;
    count = 0;
    this.name = [];
    this.unit = [];

    for (let i in this.container_detail) {
      val = this.container_detail[i]["dpT_NAM"];
      this.name.push(val);
    }
    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    this.name = this.name.sort();

    for (let j in this.name) {
      for (let i in this.container_detail) {
        if (this.name[j] == this.container_detail[i]["dpT_NAM"]) {
          count += this.container_detail[i]["avL_UNTS"];
        }
      }
      this.unit.push(count);
      count = 0;
    }
    if (this.sldDpt.length == 0) {
      this.dptLst = [];
      for (let i in this.name) {
        let obj: filterValues = {
          fltNm: "",
          avlUnt: ""
        };
        obj.fltNm = this.name[i];
        obj.avlUnt = this.unit[i];
        this.dptLst.push(obj);
      }
    }

    //SaleCondition
    val = null;
    count = 0;
    this.name = [];
    this.unit = [];

    for (let i in this.container_detail) {
      val = this.container_detail[i]["sL_CNDTN_NAM"];
      this.name.push(val);
    }
    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    this.name = this.name.sort();

    for (let j in this.name) {
      for (let i in this.container_detail) {
        if (this.name[j] == this.container_detail[i]["sL_CNDTN_NAM"]) {
          count += this.container_detail[i]["avL_UNTS"];
        }
      }
      this.unit.push(count);
      count = 0;
    }

    for (let i in this.name) {
      let obj: filterValues = {
        fltNm: "",
        avlUnt: ""
      };
      obj.fltNm = this.name[i];
      obj.avlUnt = this.unit[i];
      this.slcndLst.push(obj);
    }

    //Container Type
    val = null;
    count = 0;
    this.name = [];
    this.unit = [];

    for (let i in this.container_detail) {
      val = this.container_detail[i]["cntnR_TYP_CD"];
      this.name.push(val);
    }
    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    this.name = this.name.sort();

    for (let j in this.name) {
      for (let i in this.container_detail) {
        if (this.name[j] == this.container_detail[i]["cntnR_TYP_CD"]) {
          count += this.container_detail[i]["avL_UNTS"];
        }
      }
      this.unit.push(count);
      count = 0;
    }

    for (let i in this.name) {
      let obj: filterValues = {
        fltNm: "",
        avlUnt: ""
      };
      obj.fltNm = this.name[i];
      obj.avlUnt = this.unit[i];
      this.cnttypLst.push(obj);
    }

    //Container Size
    val = null;
    count = 0;
    this.name = [];
    this.unit = [];

    for (let i in this.container_detail) {
      val = this.container_detail[i]["cntnR_SZ_CD"];
      this.name.push(val);
    }
    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    this.name = this.name.sort();

    for (let j in this.name) {
      for (let i in this.container_detail) {
        if (this.name[j] == this.container_detail[i]["cntnR_SZ_CD"]) {
          count += this.container_detail[i]["avL_UNTS"];
        }
      }
      this.unit.push(count);
      count = 0;
    }

    for (let i in this.name) {
      let obj: filterValues = {
        fltNm: "",
        avlUnt: ""
      };
      obj.fltNm = this.name[i];
      obj.avlUnt = this.unit[i];
      this.cntszLst.push(obj);
    }

    //Color code
    val = null;
    count = 0;
    this.name = [];
    this.unit = [];

    for (let i in this.container_detail) {
      val = this.container_detail[i]["clR_CD_NM"];
      this.name.push(val);
    }
    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    this.name = this.name.sort();

    for (let j in this.name) {
      for (let i in this.container_detail) {
        if (this.name[j] == this.container_detail[i]["clR_CD_NM"]) {
          count += this.container_detail[i]["avL_UNTS"];
        }
      }
      this.unit.push(count);
      count = 0;
    }

    for (let i in this.name) {
      let obj: filterValues = {
        fltNm: "",
        avlUnt: ""
      };
      obj.fltNm = this.name[i];
      obj.avlUnt = this.unit[i];
      this.clrcdLst.push(obj);
    }

    //Price
    val = null;
    count = 0;
    this.name = [];
    this.unit = [];

    for (let i in this.container_detail) {
      val = this.container_detail[i]["sL_PRC_NC"];
      this.name.push(val);
    }
    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    this.name = this.name.sort();
    let index = this.name.indexOf(0);
    this.name.splice(index, 1);

    for (let j in this.name) {
      for (let i in this.container_detail) {
        if (this.name[j] == this.container_detail[i]["sL_PRC_NC"]) {
          count += this.container_detail[i]["avL_UNTS"];
        }
      }
      this.unit.push(count);
      count = 0;
    }

    for (let i in this.name) {
      let obj: filterValues = {
        fltNm: "",
        avlUnt: ""
      };
      obj.fltNm = this.name[i];
      obj.avlUnt = this.unit[i];
      this.pceLst.push(obj);
    }
    this.number_container = this.container_detail.length;
    val = null;
    count = 0;
    this.name = [];
    this.unit = [];
  }

  getFilterdata(data: any, type: any) {
    this.loading = false;
    this.container_detail = data;
    let maxprice: any;
    let minprice: any;

    if (type == "Country") {
      // this.cntyLst = [];
      this.cityLst = [];
      this.dptLst = [];
      this.slcndLst = [];
      this.cnttypLst = [];
      this.cntszLst = [];
      this.clrcdLst = [];
      // this.pceLst = [];
      this.Priceval = [];
    }
    if (type == "Depot") {
      // this.cityLst = [];
      // this.dptLst = [];
      this.slcndLst = [];
      this.cnttypLst = [];
      this.cntszLst = [];
      this.clrcdLst = [];
      // this.pceLst = [];
      this.Priceval = [];
    }
    if (type == "City") {
      // this.cityLst = [];
      this.dptLst = [];
      this.slcndLst = [];
      this.cnttypLst = [];
      this.cntszLst = [];
      this.clrcdLst = [];
      // this.pceLst = [];
      this.Priceval = [];
    }
    if (type == "SaleCondition") {
      // this.cityLst = [];
      // this.dptLst = [];
      // this.slcndLst = [];
      this.cnttypLst = [];
      this.cntszLst = [];
      this.clrcdLst = [];
      // this.pceLst = [];
      this.Priceval = [];
    }
    if (type == "ContainerType") {
      // this.cityLst = [];
      // this.dptLst = [];
      // this.slcndLst = [];
      // this.cnttypLst = [];
      // this.cntszLst = [];
      this.clrcdLst = [];
      // this.pceLst = [];
      this.Priceval = [];
    }
    if (type == "ContainerSize") {
      // this.cityLst = [];
      // this.dptLst = [];
      // this.slcndLst = [];
      this.cnttypLst = [];
      // this.cntszLst = [];
      this.clrcdLst = [];
      // this.pceLst = [];
      this.Priceval = [];
    }
    if (type == "ColourCode") {
      // this.cityLst = [];
      // this.dptLst = [];
      // this.slcndLst = [];
      // this.cnttypLst = [];
      // this.cntszLst = [];
      // this.clrcdLst = [];
      this.Priceval = [];
    }
    if (type == "Price") {
      // this.cityLst = [];
      // this.dptLst = [];
      // this.slcndLst = [];
      // this.cnttypLst = [];
      // this.cntszLst = [];
      // this.clrcdLst = [];
      // this.pceLst = [];
    }

    let val: any = "";
    let count: number = 0;
    val = null;
    this.name = [];
    this.unit = [];
    //Country

    // for (let i in this.container_detail) {
    //   val = this.container_detail[i]["cntrY_NAM"];
    //   this.name.push(val);
    // }
    // this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);

    // for (let j in this.name) {
    //   for (let i in this.container_detail) {
    //     if (this.name[j] == this.container_detail[i]["cntrY_NAM"]) {
    //       count += this.container_detail[i]["avL_UNTS"];
    //     }
    //   }
    //   this.unit.push(count);
    //   count = 0;
    // }

    // for (let i in this.name) {
    //   let obj: filterValues = {
    //     fltNm: "",
    //     avlUnt: ""
    //   };
    //   obj.fltNm = this.name[i];
    //   obj.avlUnt = this.unit[i];
    //   this.cntyLst.push(obj);
    // }

    //City
    val = null;
    count = 0;
    this.name = [];
    this.unit = [];

    for (let i in this.container_detail) {
      val = this.container_detail[i]["ctY_NAM"];
      this.name.push(val);
    }
    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    this.name = this.name.sort();

    for (let j in this.name) {
      for (let i in this.container_detail) {
        if (this.name[j] == this.container_detail[i]["ctY_NAM"]) {
          count += this.container_detail[i]["avL_UNTS"];
        }
      }
      this.unit.push(count);
      count = 0;
    }

    if (this.cityLst.length == 0) {
      for (let i in this.name) {
        let obj: filterValues = {
          fltNm: "",
          avlUnt: ""
        };
        obj.fltNm = this.name[i];
        obj.avlUnt = this.unit[i];
        this.cityLst.push(obj);
      }
    }
    // this.cityLst = this.cityLst.filter((v, i, a) => a.indexOf(v) === i);

    //Deopt
    val = null;
    count = 0;
    this.name = [];
    this.unit = [];

    for (let i in this.container_detail) {
      val = this.container_detail[i]["dpT_NAM"];
      this.name.push(val);
    }
    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    this.name = this.name.sort();

    for (let j in this.name) {
      for (let i in this.container_detail) {
        if (this.name[j] == this.container_detail[i]["dpT_NAM"]) {
          count += this.container_detail[i]["avL_UNTS"];
        }
      }
      this.unit.push(count);
      count = 0;
    }
    if (this.dptLst.length == 0) {
      for (let i in this.name) {
        let obj: filterValues = {
          fltNm: "",
          avlUnt: ""
        };
        obj.fltNm = this.name[i];
        obj.avlUnt = this.unit[i];
        this.dptLst.push(obj);
      }
    }

    //SaleCondition
    val = "";
    count = 0;
    this.name = [];
    this.unit = [];

    for (let i in this.container_detail) {
      val = this.container_detail[i]["sL_CNDTN_NAM"];
      this.name.push(val);
    }
    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    this.name = this.name.sort();

    for (let j in this.name) {
      for (let i in this.container_detail) {
        if (this.name[j] == this.container_detail[i]["sL_CNDTN_NAM"]) {
          count += this.container_detail[i]["avL_UNTS"];
        }
      }
      this.unit.push(count);
      count = 0;
    }
    if (this.slcndLst.length == 0) {
      for (let i in this.name) {
        let obj: filterValues = {
          fltNm: "",
          avlUnt: ""
        };
        obj.fltNm = this.name[i];
        obj.avlUnt = this.unit[i];
        this.slcndLst.push(obj);
      }
    }

    //Container Type
    val = "";
    count = 0;
    this.name = [];
    this.unit = [];

    for (let i in this.container_detail) {
      val = this.container_detail[i]["cntnR_TYP_CD"];
      this.name.push(val);
    }
    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    this.name = this.name.sort();

    for (let j in this.name) {
      for (let i in this.container_detail) {
        if (this.name[j] == this.container_detail[i]["cntnR_TYP_CD"]) {
          count += this.container_detail[i]["avL_UNTS"];
        }
      }
      this.unit.push(count);
      count = 0;
    }
    if (this.cnttypLst.length == 0) {
      for (let i in this.name) {
        let obj: filterValues = {
          fltNm: "",
          avlUnt: ""
        };
        obj.fltNm = this.name[i];
        obj.avlUnt = this.unit[i];
        this.cnttypLst.push(obj);
      }
    }
    this.cnttypLst = this.cnttypLst.filter((v, i, a) => a.indexOf(v) === i);

    //Container Size
    val = "";
    count = 0;
    this.name = [];
    this.unit = [];

    for (let i in this.container_detail) {
      val = this.container_detail[i]["cntnR_SZ_CD"];
      this.name.push(val);
    }
    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    this.name = this.name.sort();
    if (this.cntszLst.length == 0) {
      for (let j in this.name) {
        for (let i in this.container_detail) {
          if (this.name[j] == this.container_detail[i]["cntnR_SZ_CD"]) {
            count += this.container_detail[i]["avL_UNTS"];
          }
        }
        this.unit.push(count);
        count = 0;
      }
    }
    if (this.cntszLst.length == 0) {
      for (let i in this.name) {
        let obj: filterValues = {
          fltNm: "",
          avlUnt: ""
        };
        obj.fltNm = this.name[i];
        obj.avlUnt = this.unit[i];
        this.cntszLst.push(obj);
      }
    }

    //Color code
    val = "";
    count = 0;
    this.name = [];
    this.unit = [];

    for (let i in this.container_detail) {
      val = this.container_detail[i]["clR_CD_NM"];
      this.name.push(val);
    }
    this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    this.name = this.name.sort();

    for (let j in this.name) {
      for (let i in this.container_detail) {
        if (this.name[j] == this.container_detail[i]["clR_CD_NM"]) {
          count += this.container_detail[i]["avL_UNTS"];
        }
      }
      this.unit.push(count);
      count = 0;
    }
    if (this.clrcdLst.length == 0) {
      for (let i in this.name) {
        let obj: filterValues = {
          fltNm: "",
          avlUnt: ""
        };
        obj.fltNm = this.name[i];
        obj.avlUnt = this.unit[i];
        this.clrcdLst.push(obj);
      }
    }

    //Price
    // val = null;
    // count = 0;
    // this.name = [];
    // this.unit = [];

    // for (let i in this.container_detail) {
    //   val = this.container_detail[i]["sL_PRC_NC"];
    //   this.name.push(val);
    // }

    // this.name = this.name.filter((v, i, a) => a.indexOf(v) === i);
    // let index = this.name.indexOf(0);
    // this.name.splice(index, 1);

    // for (let j in this.name) {
    //   for (let i in this.container_detail) {
    //     if (this.name[j] == this.container_detail[i]["sL_PRC_NC"]) {
    //       count += this.container_detail[i]["avL_UNTS"];
    //     }
    //   }
    //   this.unit.push(count);
    //   count = 0;
    // }

    // for (let i in this.name) {
    //   let obj: filterValues = {
    //     fltNm: "",
    //     avlUnt: ""
    //   };
    //   obj.fltNm = this.name[i];
    //   obj.avlUnt = this.unit[i];
    //   this.pceLst.push(obj);
    // }
    for (let i in this.container_detail) {
      val = this.container_detail[i]["sL_PRC_NC"];
      if (val >= 0 && val <= 1000) {
        this.Priceval.push("0 - 1000");
      }
      if (val >= 1001 && val <= 1500) {
        this.Priceval.push("1001 - 1500");
      }
      if (val >= 1501 && val <= 2000) {
        this.Priceval.push("1501 - 2000");
      }
      if (val >= 2001 && val <= 2500) {
        this.Priceval.push("2001 - 2500");
      }
      if (val >= 2501 && val <= 3000) {
        this.Priceval.push("2501 - 3000");
      }
      if (val >= 3001) {
        this.Priceval.push("3001 - Above");
      }
      // for (let index = 0; index < this.totalPrice.length; index++) {
      //   const element = this.totalPrice[index];
      //   minprice = element.substr(0, element.indexOf(" - ")); // "72"
      //   maxprice = element.substr(element.indexOf(" ") + 1);
      //   maxprice = maxprice.replace(/^- +/i, "");
      //   if (val >= minprice && val <= maxprice) {
      //     this.Priceval.push(element);
      //   }
      // }
    }
    this.Priceval = this.Priceval.filter((v, i, a) => a.indexOf(v) === i);
    this.Priceval = this.Priceval.sort();

    this.number_container = this.container_detail.length;


  }

  // priceFilter(priceval) {
  //   let result = [];
  //   let minval = Math.min(...priceval);
  //   let maxval = Math.max(...priceval);
  //   // considering ranges `1-4, 5-8, 9-12, 13-16, 17-20, 21-24`
  //   for (let i = minval; i < maxval; i += 1000) {
  //     let pricesting = i + " - " + (i + 999);
  //     result.push(pricesting);
  //   }
  //   this.Priceval = result;
  //   this.totalPrice = this.Priceval;
  // }
}



// WEBPACK FOOTER //
// ./src/app/buycontainertrade/buycontainertrade.component.ts